/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Button, Container, Form, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { colorStringToColorArray } from 'doka';
import { DokaImageEditor } from 'react-doka';
import ReactQuill from 'react-quill';
import axios from 'axios';
import moment from 'moment'; 
import DatePicker from "react-datepicker";
import FileType from "file-type/browser";
import heic2any from 'heic2any';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { setEditorPlugins, getEditorDefaults, circleCropMask } from 'shared/doka';
import { mobileNumberFormat, ArrayValueReorder, commonMobileNumberFormat } from 'shared/modifiers';
import { IMAGE_TYPES } from 'shared/settings/config';
import {
    citylist, locationdetail, locationlist, loctemplatelist,
    saleimagelist, saleadd, saledetail, saleupdate,itemlist,
    statecitybyzipcode, statelist, timezonelist, saleimageadd,
    saleimageupdate,salestaffcheckpoint, saleDateValidity, stateCityCheck
} from 'shared/settings/apiconfig';
import Validators from 'shared/validators';
import { ToasterMessage } from 'shared/toast/toast';

// style imports
import 'doka/doka.css';
import "react-datepicker/dist/react-datepicker.css";
import './SalesEdit.scss';
import { ExtendSnowTheme } from 'shared/editor/quill-editor';
import {DebounceInput} from 'react-debounce-input';
import { NoData } from 'features/components/redirect/NoData';
import {
    builingIcon as buildingIcon,
    hashtagIcon,
    infoIcon,
    locationIcon,
    mailIcon,
    phoneCallIcon,
    tagIcon,
    userIcon
} from '../../../../icons';

/* initializes doka editing plugins */
setEditorPlugins();

// sale constant values
const step = { 1: 'detail', 2: 'settings', 3: 'media' };
const formControl = [{ key: 'termsandconditions', value: 'Terms & Conditions' }, { key: 'invoicemessage', value: 'Invoice Message' }, { key: 'shippinginfo', value: 'Shipping Info' }, { key: 'paymentinfo', value: 'Payment Info' }]

/**
 * this page is used to show sale edit or create
 * 
 * @param props
 * 
 * @param saleId
 * 
 * @return html code for sales edit and create
 * 
**/

const quillAllowedRegexPattern =/^[A-Za-z0-9 .,!#\$%&\*\(\)\-\/'"\+\?<>\_\[\]:;@“”`‘’]+$/;

export class SalesEdit extends Component {
    viewModal;
    templateId;
    templateData;
    locations;
    currentImage;
    saleId;
    edit;
    category;
    imageData;
    viewModalName;
    editModalName;
    templateEditValue;
    timezone;
    statelist;
    currentStartDate;
    currentEndDate;
    profileEditorDefaults;
    bannerEditorDefaults;
    imageEditorDefaults;
    isTimezoneChanged = false;
    duration = [{ value: 90, text: '90 minutes' }, { value: 120, text: '120 minutes' }, { value: 150, text: '150 minutes' }, { value: 180, text: '180 minutes' }];
    modules = {
        toolbar: [
            ['underline'], 
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean']
        ],
        clipboard: {
            matchVisual: false,
            matchers: [
                ["span", (node, delta) => {
                  delta.ops.forEach((op) => {
                    if (op.attributes) {
                      const isLink = !!op.attributes.link;
                      Object.keys(op.attributes).forEach((attr) => {
                        if (attr !== "link") delete op.attributes[attr]; 
                      });
                      if (!isLink) delete op.attributes.color;
                      delete op.attributes.background;
                    }
                  });
                  return delta;
                }],
                [Node.ELEMENT_NODE, (node, delta) => {
                  const blocked = [
                    "bold",
                    "italic",
                    "strike",
                    "size",
                    "font",
                    "header",
                    "color",
                    "background",
                  ];
                  delta.ops.forEach((op) => {
                    if (op.attributes) {
                      blocked.forEach((attr) => delete op.attributes[attr]);
                    }
                  });
                  return delta;
                }],
                
                ["a", (node, delta) => delta],
            ],
        },
        magicUrl: true,
        keyboard: {
            bindings: {
                // Disable Ctrl+B
                bold: { key: "B", shortKey: true, handler: () => false },
                // Disable Ctrl+I
                italic: { key: "I", shortKey: true, handler: () => false },
            }
        }
    };
    
    profileTargetImage;
    

    constructor(props) {
        super(props);
        this.timeoutInterval = {};
        this.edit = false;
        this.textEditorRef = null;
     

        /* check for create or edit sale */
        this.saleId = this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1);
        if (isNaN(Number(this.saleId))) {
            this.edit = true;
        }

        this.state = {
            currentPage: 1,
            formLoading: true,
            showEditMsg: false,
            loading: false,
            saleid: this.edit ? null : this.saleId,
            city: [],
            chars_left: 500,
            saleProvenanceCharLeft: 750,
            chars_left_Checkpoint: 200,
            showConfirmModal: false,
            showUpdateModal: false,
            currentDate: new Date(),
            currentStartDate: new Date(),
            currentEndDate: new Date(),
            tempStarttime:null,
            tempEndtime:null,
            tempTimeZone:null,
            startDate:new Date(),
            checkSaleStatus: false,
            itemlist: [],
            restoreTax :  '',
            restoreBuyerspremium: '',
            isLocked: '',
            restoreIrm : '',  
            detail: {
                locationid: { value: '', valid: false, error: '', validators: [Validators.required()] },
                franchiseid: { value: '', valid: true, error: ''},
                contactmobile: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.mobile(), Validators.maxLength(15)] },
                contactemail: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)] },
                contactname: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(45)] },
                // ispublic: { value: false, error: '', valid: true },
                title: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(100)] },
                address1: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.maxLength(45)] },
                address2: { value: '', valid: false, error: '', validators: [Validators.maxLength(45)] },
                zipcode: { value: '', error: '', valid: false, validators: [Validators.required()] },
                state: { value: '', error: '', valid: false, validators: [Validators.required()] },
                city: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(45) ]},
                client: { value: '', error: '', valid: true, validators: [Validators.maxLength(45)] },
                formValid: false
            },
            settings: {
                timezoneid: { value: '', error: '', valid: false, validators: [Validators.required()] },
                starttime: { value: '', error: '', valid: false, validators: [Validators.required()] },
                endtime: { value: '', error: '', valid: false, validators: [Validators.required()] },
                closeduration: { value: 90, error: '', valid: true, validators: [Validators.required()] },
                
                // duration: { value: '', error: '', valid: false, validators: [Validators.required()] },
                // staggeredtime: { value: '', error: '', valid: false, validators: [Validators.required()] },
                // staggeredgroup: { value: '', error: '', valid: false, validators: [Validators.required()] },
                tax: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxDigit(3)] },
                buyerspremium: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxDigit(3)] },
                applytaxonbp: { value: '', error: '', valid: true },
                isshippable: { value: '', error: '', valid: true },
                pickupinfo: { value: '', error: '', valid: true, validators: [Validators.maxLength(500)] },
                termsandconditions: { value: '', error: '', valid: false, validators: [Validators.required()] },
                provenance: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(750)] },
                invoicemessage: { value: '', error: '', valid: false, validators: [Validators.required()] },
                // detail: { value: '', error: '', valid: false, validators: [Validators.required()] },
                shippinginfo: { value: '', error: '', valid: false, validators: [Validators.required()] },
                paymentinfo: { value: '', error: '', valid: false, validators: [Validators.required()] },
                itemreceiptmethod : { value: {}, valid: false, error: '', validators: [Validators.required()] },
                salestaffcheckpointid: { value: '', error: '', valid: true },
                salestaffcheckpoint: { value: '', error: '', valid: true },
                formValid: false,
                viewModal: false,
                editModal: false,
                isTemplateData: false,
                pickuptime : { value: '', error: '', valid: true }
            },
            media: {
                banner: { value: '', error: '', imgSrc: null, tempImg: null },
                profile: { value: '', error: '', imgSrc: null, tempImg: null },
                modal: false,
                ismedia: false
            },
            itemMedia: [
                { value: '', error: '', imgSrc: null, tempImg: null },
                { value: '', error: '', imgSrc: null, tempImg: null },
                { value: '', error: '', imgSrc: null, tempImg: null }
            ],
            franchisedetail: [],
            errorpageredirect: false,
            formValid: false,
            status: "active",
            saleStatus: { show: false, type: '', message: '' },
            minimumTime: new Date(),
            EndDateminTime: new Date(),
            pickupminTime: '',
            minDate: new Date(),
            pickupmindate :  new Date(),
            zonename: "",
            isSafari: false,
            locationDetails: {},
            timezoneChangeConfirm: false,
            isdelivery: '',
            ispickup: '',
            isshipping: '',
            irmValid: false,
            checkpointList: [],
            checkpointInput: false,
            saleEndTimeChangeConfirm: false,
            stateCityError: '',
            cityStateIsValid: true,
            cityDropdownValue: [],
            showCityDropdown: false,
            invalidIrm: [],
            formErrorMessage: '',
            pickupDateWithoutFormat: '',
            setSaleImageErrorMessage: "",
            setItemImageErrorMessage: "",
            processSaleImage: false,
            processItemImageIndex: null
        }

        this.viewModal = false;
        this.templateId = 1;
        this.templateData = [];
        this.locations = [];
        this.currentImage = 'banner';
        this.category = [];
        this.timezone = [];
        this.statelist = [];
        this.imageData = {};
        this.viewModalName = '';
        this.editModalName = '';
        this.templateEditValue = '';
        this.currentStartDate = new Date();
        this.currentEndDate = new Date();
        this.profileTargetImage = {width: 600, height: 400 };
        this.profileEditorDefaults = {
            imageCropAspectRatio: 600 / 400,
            cropEnableSelectPreset: false,
            imageCropMinSize: { width: 600, height: 400 },
            // willRenderCanvas: (shapes, state) => circleCropMask(shapes, state)
        };
        this.itemEditorDefaults = {
            imageCropAspectRatio: 1,
            cropEnableSelectPreset: false,
            imageCropMinSize: { width: 400, height: 400 },
            // willRenderCanvas: (shapes, state) => circleCropMask(shapes, state)
        };
        this.bannerEditorDefaults = {
            imageCropAspectRatio: 29 / 5,
            imageBackgroundColor: colorStringToColorArray('#fff'),
            cropEnableButtonRotateRight: false,
            cropEnableButtonRotateLeft: false,
            cropEnableSelectPreset: false,
            imageCropMinSize: { width: 1200, height: 250 }
        };
        this.imageEditorDefaults = {};
        this.toasterWidth = '';
        this.timezoneTemp = null;
        this.errorMessage = "The Zip code, State and City not matching please enter correct information";
        this.imageIndex = '';
    }
    componentDidMount() {
        this.getLocationTimeZoneStateList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1;
        this.setState({
            isSafari
        })
        this.getsalestaffCheckpointList()
    }

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.props.history.push({ pathname: '/sales', state: this.props.location.state })
        }
    }

    getItemList = () => {
        let data = {
            field: ['id'],
            filter: [
                { field: "itemstatus", value: 'Ready', op: "=", join: "AND" },
                { field: "saleid", value: this.state.saleid, op: "=", join: "AND" }
            ]
        }
        axios.post(getSellerUrl(itemlist), JSON.stringify(data), getSellerHeaders()).then(response =>{
            let data = response.data.data
            this.setState({
                itemlist: data
            })

        })
    }

    /* Get Location, timezone and state list */
    getLocationTimeZoneStateList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
            await axios.get(getSellerUrl(timezonelist), getSellerHeaders()),
            await axios.get(getSellerUrl(statelist), getSellerHeaders())

        ])
            .then(response => {
                this.locations = ArrayValueReorder(response[0].data.data, 'title');
                this.timezone = ArrayValueReorder(response[1].data.data, 'zonename');
                this.statelist = ArrayValueReorder(response[2].data.data, 'state');
                if (this.edit) {
                    this.setState({
                        detail: {
                            ...this.state.detail,
                            locationid: {
                                ...this.state.detail.locationid,
                                value: this.locations.length === 1 ? this.locations[0]['id'] : '',
                                valid: this.locations.length === 1 ? true : false
                            },
                            state: {
                                ...this.state.detail.state,
                                value: this.statelist.length === 1 ? this.statelist[0]['state'] : '',
                                valid: this.statelist.length === 1 ? true : false
                            }
                        },
                        formLoading: false
                    }, () => {
                        if (this.locations.length === 1)
                            this.getTimezoneContactName();
                    })
                }
                else if (!this.edit)
                    this.getSaleData();
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
                this.setState({
                    ...this.state,
                    formLoading: false,
                    saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    }

    /* get state and city for zipcode */
    getStateCity = () => {
        let cityList = this.state.city;
        if (this.state.detail.zipcode.value && this.state.detail.zipcode.value.toString().length > 4) {
            axios.get(getSellerUrl(`${statecitybyzipcode}/${this.state.detail.zipcode.value}`), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.data.length) {
                            cityList.push(response.data.data[0].city);
                            cityList = cityList.filter((city, index) => {
                                const _city = JSON.stringify(city);
                                return index === cityList.findIndex(obj => {
                                    return JSON.stringify(obj) === _city;
                                });
                            });

                            this.setState({
                                ...this.state,
                                city: cityList,
                                detail: {
                                    ...this.state.detail,
                                    // city: { ...this.state.detail.city, value: response.data.data[0].city, valid: response.data.data[0].city ? true : false, error: response.data.data[0].city ? '' : this.state.detail.city.error },
                                    state: { ...this.state.detail.state, value: response.data.data[0].state, valid: response.data.data[0].state ? true : false, error: response.data.data[0].state ? '' : this.state.detail.state.error }
                                },
                                formLoading: false
                            }, () => {
                                this.getCity('zipcode')
                                this.checkStateAndCity(this.state.detail.zipcode.value, this.state.detail.state.value, this.state.detail.city.value);
                            })
                        }
                        else {
                            this.setState({
                                ...this.state,
                                city: [],
                                detail: {
                                    ...this.state.detail,
                                    // city: { ...this.state.detail.city, value: '', valid: false, error: '' },
                                    state: { ...this.state.detail.state, value: '', valid: false }
                                },
                                formLoading: false
                            }, () => this.checkFormValidity())

                        }
                    }
                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                    });
                });
        }
    }
    // get staff checkpoint questions for sale setup
    getsalestaffCheckpointList = () => {
        axios.get(getSellerUrl(`${salestaffcheckpoint}`), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    let checkpointsObject = response?.data?.data?.data ? response?.data?.data?.data : []
                    let checkList = []
                    checkpointsObject.map((item, index) =>{
                        Object.keys(item).map(function(keyName, keyIndex) {
                            checkList.push({id: keyName, question: item[keyName]})
                        })
                    })
                    this.setState({
                        checkpointList: checkList
                    })
                }
            })
            .catch(error => {
            this.setState({
                ...this.state,
                formLoading: false,
            });
        });
    }

    /* Get contact name for location */
    getTimezoneContactName = (edit = false, locationirm) => {
        if (this.state.detail.locationid.value) {
            axios.post(getSellerUrl(`${locationdetail}/${this.state.detail.locationid.value}`), JSON.stringify({ field: ['contactname', 'timezone', 'email', 'phone', 'applytaxonbp','locationitemreceipt',"franchisedetail"] }), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        let timezoneId = this.timezone.filter(x => x.zonename === response.data.data[0]['timezone'])[0]['id'];

                        const franchiseArray = response.data.data[0].franchisedetail ? response.data.data[0].franchisedetail.split(",") : [];
                        this.setState({
                            franchisedetail: franchiseArray,
                            formLoading: false,
                        })

                        if(this.edit){
                            let irmdata = response.data.data[0]
                            
                            this.setState({
                                settings: {
                                    ...this.state.settings,
                                    itemreceiptmethod: {
                                        ...this.state.settings.itemreceiptmethod,
                                        value: response.data.data[0]['locationitemreceipt'] ? response.data.data[0]['locationitemreceipt'] : {"pickup": false, "delivery": false, "shipping": false}
                                    }
                                }
                            }, () => {
                              this.setItemReceiptMethod(this.state.settings.itemreceiptmethod.value);
                              this.disableInvalidIrm(this.state.settings.itemreceiptmethod.value);
                            });

                            
                        }
                        this.disableInvalidIrm(response.data.data[0]['locationitemreceipt']);
                        if (edit) {
                            this.setState({
                                locationDetails: response.data.data[0],
                                settings: {
                                    ...this.state.settings,
                                  /*   applytaxonbp: {
                                        ...this.state.settings.applytaxonbp,
                                        value: response.data.data[0]['applytaxonbp'],
                                        valid: response.data.data[0]['applytaxonbp'] ? true : false,
                                    }, */
                                },
                            }, () => {
                                this.checkFormValidity();
                                // if (timezoneId)
                                //     this.calculateTimeZonetime();
                            });
                        } else {
                            this.setState({
                                locationDetails: response.data.data[0],
                                detail: {
                                    ...this.state.detail,
                                    contactname: {
                                        ...this.state.detail.contactname,
                                        value: response.data.data[0]['contactname'],
                                        valid: response.data.data[0]['contactname'] ? true : false,
                                        error: response.data.data[0]['contactname'] ? '' : 'Please enter value'
                                    },
                                    contactemail: {
                                        ...this.state.detail.contactemail,
                                        value: response.data.data[0]['email'],
                                        valid: response.data.data[0]['email'] ? true : false,
                                        error: response.data.data[0]['email'] ? '' : 'Please enter value'

                                    },
                                    contactmobile: {
                                        ...this.state.detail.contactmobile,
                                        value: response.data.data[0]['phone'],
                                        valid: response.data.data[0]['phone'] ? true : false,
                                        error: response.data.data[0]['phone'] ? '' : 'Please enter value'
                                    },
                                },
                                settings: {
                                    ...this.state.settings,
                                    timezoneid: {
                                        ...this.state.settings.timezoneid,
                                        value: timezoneId,
                                        valid: timezoneId ? true : false,
                                        error: timezoneId ? '' : 'Please enter value'
                                    },
                                    applytaxonbp: {
                                        ...this.state.settings.applytaxonbp,
                                        value: response.data.data[0]['applytaxonbp'],
                                        valid: response.data.data[0]['applytaxonbp'] ? true : false,
                                    },
                                    isshippable: {
                                        ...this.state.settings.isshippable,
                                        value: false,
                                        valid: response.data.data[0]['isshippable'] ? true : false,
                                    }
                                },
                                formLoading: false
                            }, () => {
                                this.checkFormValidity();
                                if (timezoneId)
                                    this.calculateTimeZonetime();
                            });
                        }
                     
                        
                        setTimeout(()=> {
                            if(this.state.locationPickup || this.state.locationShipping || this.state.locationDelivery){
                                this.setState({
                                    locationIrmvalid: false
                                })
                            }
                            else{
                                this.setState({
                                    locationIrmValid: true
                                })
                            }
                        })

                    }
                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                    });
                });
        }
        else {
            this.setState({
                detail: {
                    ...this.state.detail,
                    contactname: {
                        ...this.state.detail.contactname,
                        value: '',
                        valid: false,
                        error: 'Please enter value'
                    },
                   
                },
                formLoading: false
            }, () => this.checkFormValidity());

        }
    }

    /* get city list */
    getCity = (callFrom) => {
        let cityList = [];
        if (this.state.detail.state.value) {
            axios.get(getSellerUrl(`${citylist}/${this.state.detail.state.value}`), getSellerHeaders())
                .then(response => {
                    cityList = ArrayValueReorder(response.data.data, 'city');
                    cityList = cityList.filter((city, index) => {
                        const _city = JSON.stringify(city);
                        return index === cityList.findIndex(obj => {
                            return JSON.stringify(obj) === _city;
                        });
                    });
                    if ((this.edit || callFrom === 'state') && callFrom !== 'zipcode') {
                        this.setState({
                            city: cityList,
                            detail: {
                                ...this.state.detail,
                                city: {
                                    ...this.state.detail.city,
                                    error: '',
                                    valid: cityList.length === 1 ? true : false,
                                    value: cityList.length === 1 ? cityList[0]['city'] : ''
                                }
                            }
                        }, () => this.checkFormValidity());
                    }
                    else {
                        this.setState({
                            city: cityList
                        }, () => this.checkFormValidity());
                    }

                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                    });
                });
        }
    }


    /* Get sale data for edit */
    getSaleData = () => {
        let formData = {};
        if (!this.edit) {
            /* get user details */
            axios.get(getSellerUrl(`${saledetail}/${this.saleId}`), getSellerHeaders())
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.data.length == 0) {
                            this.setState({
                                errorpageredirect: true,
                                errorType: "noData"
                            })
                            return;
                        }
                        formData = response.data.data[0];
                        /* set data to state*/
                        this.setState({
                            ...this.state,
                            status: response.data.data[0].status,
                            detail: {
                                ...this.state.detail,
                                locationid: { ...this.state.detail.locationid, value: formData.locationid, valid: formData.locationid ? true : false },
                                franchiseid: { ...this.state.detail.franchiseid, value: formData.franchiseid },
                                contactmobile: { ...this.state.detail.contactmobile, value: formData.contactmobile ? mobileNumberFormat(formData.contactmobile) : '', valid: formData.contactmobile ? true : false },
                                contactemail: { ...this.state.detail.contactemail, value: formData.contactemail, valid: formData.contactemail ? true : false },
                                contactname: { ...this.state.detail.contactname, value: formData.contactname, valid: formData.contactname ? true : false },
                                // ispublic: { ...this.state.detail.ispublic, value: formData.ispublic, valid: true },
                                title: { ...this.state.detail.title, value: formData.title, valid: formData.title ? true : false },
                                address1: { ...this.state.detail.address1, value: formData.address1, valid: formData.address1 ? true : false },
                                address2: { ...this.state.detail.address2, value: formData.address2, valid: true, },
                                zipcode: { ...this.state.detail.zipcode, value: formData.zipcode, valid: formData.zipcode ? true : false },
                                state: { ...this.state.detail.state, value: formData.state, valid: formData.state ? true : false },
                                city: { ...this.state.detail.city, value: formData.city, error: '', valid: formData.city ? true : false },
                                client: { ...this.state.detail.client, value: formData.client, valid: true }

                            },
                            settings: {
                                ...this.state.settings,
                                timezoneid: { ...this.state.settings.timezoneid, value: formData.timezoneid, valid: formData.timezoneid ? true : false },
                                starttime: { ...this.state.settings.starttime, value: formData.starttime ? new Date(moment(formData.starttime)) : '', valid: formData.starttime ? true : false },
                                endtime: { ...this.state.settings.endtime, value: formData.endtime ? new Date(moment(formData.endtime)) : '', valid: formData.endtime ? true : false },
                                closeduration: { ...this.state.settings.closeduration, value: formData.closeduration ? formData.closeduration : 90, valid: true },
                                // duration: { ...this.state.settings.duration, value: formData.duration },
                                // staggeredtime: { ...this.state.settings.staggeredtime, value: formData.staggeredtime },
                                // staggeredgroup: { ...this.state.settings.staggeredgroup, value: formData.staggeredgroup,valid: true  },
                                itemreceiptmethod: {...this.state.settings.itemreceiptmethod, value: formData.saleitemreceiptmethod ? JSON.parse(formData.saleitemreceiptmethod) : {"pickup": false, "delivery": false, "shipping": false}},
                                tax: { ...this.state.settings.tax, value: parseFloat(formData.tax).toFixed(3), valid: formData.tax || formData.tax === 0 ? true : false },
                                buyerspremium: { ...this.state.settings.buyerspremium, value: parseFloat(formData.buyerspremium).toFixed(3), valid: formData.buyerspremium || formData.buyerspremium === 0 ? true : false },
                                applytaxonbp: { ...this.state.settings.applytaxonbp, value: formData.applytaxonbp, valid: formData.applytaxonbp ? true : false },
                                isshippable: { ...this.state.settings.isshippable, value: formData.isshippable , valid: formData.isshippable ? true : false },
                                pickupinfo: { ...this.state.settings.pickupinfo, value: formData.pickupinfo ? formData.pickupinfo : '', valid: true },
                                termsandconditions: { ...this.state.settings.termsandconditions, value: formData.termsandconditions ? JSON.stringify(JSON.parse(formData.termsandconditions)['content']) : '', valid: formData.termsandconditions ? true : false },
                                provenance: { ...this.state.settings.provenance, value: formData.provenance ? formData.provenance : '', valid: formData.provenance ? true : false },
                                invoicemessage: { ...this.state.settings.invoicemessage, value: formData.invoicemessage ? JSON.stringify(JSON.parse(formData.invoicemessage)['content']) : '', valid: formData.invoicemessage ? true : false },
                                // detail: { ...this.state.settings.detail, value: formData.detail ? JSON.stringify(JSON.parse(formData.detail)['content']) : '', valid: formData.detail ? true : false },
                                shippinginfo: { ...this.state.settings.shippinginfo, value: formData.shippinginfo ? JSON.stringify(JSON.parse(formData.shippinginfo)['content']) : '', valid: formData.shippinginfo ? true : false },
                                paymentinfo: { ...this.state.settings.paymentinfo, value: formData.paymentinfo ? JSON.stringify(JSON.parse(formData.paymentinfo)['content']) : '', valid: formData.paymentinfo ? true : false },
                                salestaffcheckpointid: { ...this.state.settings.salestaffcheckpointid, value: formData.salestaffcheckpointid ? formData.salestaffcheckpointid : '', valid: true ,error: ''},
                                salestaffcheckpoint: { ...this.state.settings.salestaffcheckpoint, value: formData.salestaffcheckpoint ? formData.salestaffcheckpoint : '', valid: formData.salestaffcheckpointid === 'QM' ? false : true , validators: [Validators.required()]},  
                                pickuptime: { ...this.state.settings.pickuptime, value: formData.pickuptime ? new Date(moment(formData.pickuptime)) : '',},                             
                            },
                            media: {
                                ...this.state.media,
                                banner: { ...this.state.media.banner, value: formData.banner },
                                profile: { ...this.state.media.profile, value: formData.profile }
                            },
                            isLocked: response.data.data[0].islocked,
                            checkSaleStatus: formData.status === 'Closed' ? true : false,
                            tempStarttime: formData.starttime ,
                            tempEndtime:formData.endtime ,
                            tempTimeZone:formData.timezonename,
                            restoreTax :   parseFloat(formData.tax).toFixed(3),
                            restoreBuyerspremium: parseFloat(formData.buyerspremium).toFixed(3),
                            restoreIrm : formData.saleitemreceiptmethod ? JSON.parse(formData.saleitemreceiptmethod) :  {"pickup": false, "delivery": false, "shipping": false},
                      
                            checkpointInput: formData.salestaffcheckpointid === 'QM' ? true : false,
                            pickupDateWithoutFormat: formData.pickuptime
                        }, () => {
                            this.getItemList()
                            this.getCity('zipcode');
                            this.checkFormValidity();
                            this.calculateTimeZonetime(true);
                        
                            this.setItemReceiptMethod(formData.saleitemreceiptmethod);
                            // this.disableInvalidIrm(formData.saleitemreceiptmethod);
                            this.getTimezoneContactName(true);
                            this.checkStateAndCity(this.state.detail.zipcode.value, this.state.detail.state.value, this.state.detail.city.value);
                            this.checkPickupTime();
                        });
                      
                    }
                    
                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        // saleStatus: { show: true, type:'danger', message: error.response.data['message'] }
                    });
                    if(error.response?.status == 401 || error.response?.status == 404) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    }     
                });
        }

    }
  
    checkPickupTime = (pickupdate) => {
        if (new Date(this.state.settings.endtime.value).setHours(0,0,0) >= this.state.settings.pickuptime.value &&  this.state.settings.pickuptime.value) {
            this.setState({
                ...this.state,
                settings: {
                    ...this.state.settings,
                    pickuptime: {
                        value: this.state.settings.pickuptime.value,
                        error: "Pickup date should be greater than end date"
                    }
                },
                formErrorMessage: "Pickup date should be greater than end date"
            })
        }
    } 
   

    /* get sale images */
    getSaleImages = (loader = true) => {
        try{
        let filter = [{ field: 'saleid', value: Number(this.state.saleid), op: '=', join: 'AND' }];
        this.setState({ formLoading: loader });
        axios.post(getSellerUrl(saleimagelist), JSON.stringify({ filter: filter }), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    if (response.data['data'].length) {
                        response.data['data'].forEach(image => {
                            this.setState({
                                ...this.state,
                                media: {
                                    ...this.state.media,
                                    media: true,
                                    [image['name']]: {
                                        ...this.state.media[image['name']],
                                        imgSrc: image['url']
                                    }
                                },
                                formLoading: false
                            });
                            if (image.itemimageurl) {
                                const parsedArray = JSON.parse(image.itemimageurl);
                                const updatedItemMedia = [];
                                if (Array.isArray(parsedArray) && parsedArray.length > 0) {
                                    for (let i = 0; i < parsedArray.length; i++) {
                                        updatedItemMedia.push({
                                            value: null, 
                                            imgSrc: parsedArray[i] || '',
                                            error: '', 
                                            tempImg: null
                                        });
                                    }
                                } else {
                                    updatedItemMedia = this.state.itemMedia
                                }

                                this.setState({ 
                                    itemMedia: updatedItemMedia 
                                });
                            }
                            this.imageData[image['name']] = image['id'];
                        });
                    }
                    else {
                        this.setState({ formLoading: false })
                    }
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                    media: {
                        ...this.state.media,
                        media: false,
                    },
                    formLoading: false,
                    saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
        }catch(e){
             console?.clear()
        }
    }

    scrollToTop = () => {
        const salePage = document.querySelector('.sale-page');
        if (salePage) salePage.scrollTop = 0;
        window.scrollTo(0, 0);
    }

    /* called when save button clicked */
    setStep = (stepNumber) => {
        if (stepNumber === this.state.currentPage) {
            return
        }
        if (stepNumber === 2 && this.edit && !this.state.settings.isTemplateData) {
            this.templateDetails();
        }
        else if (stepNumber === 3 && this.edit)
            this.submitForm();
        else {
            this.setState({
                ...this.state,
                currentPage: stepNumber
            }, () => {
                if (stepNumber === 3 && !this.edit)
                    this.getSaleImages();

                if (stepNumber === 2 && !this.edit)
                    this.checkFormValidity();
            });
        }
    } 
    /** called when timezone changes - CNGD-3028*/
  toTimeZone(date,prevzone, timezone) {
      let dateTime = moment(date).format('YYYY/MM/DD hh:mm A');
      let prevDate = moment.tz(dateTime, 'YYYY/MM/DD hh:mm A', prevzone).format();
      let convertDate = moment.tz(prevDate, timezone).format('YYYY/MM/DD hh:mm A');
      return convertDate;
 
        }
    // properly convert to boolean (Standard method)
    getBool(val) {
        try{
            if(val)
            return !!JSON.parse(String(val).toLowerCase());
            else
            return false
        }catch(e){
            return false
        }
    }
    // receipt check box handling
    receiptCheckBox = (event) => {

        let eventValue = event.target.checked;
        this.setState({
            showEditMsg: true,
            settings: {
                ...this.state.settings,
                itemreceiptmethod: {
                    ...this.state.settings.itemreceiptmethod,
                    value: {
                        ...this.state.settings.itemreceiptmethod.value,
                        [event.target.name]: eventValue
                    }
                }
            }
        }, () => {
            this.validateIRM();
        });
    }
    validateIRM = () => {
        let isIRMValid = false;
        const keys = Object.keys(this.state.settings.itemreceiptmethod.value);
        keys.forEach(key => {
            if (this.state.settings.itemreceiptmethod.value[key]) {
                isIRMValid = true;
            }
        });

        this.setState({
            settings: {
                ...this.state.settings,
                itemreceiptmethod: {
                    ...this.state.settings.itemreceiptmethod,
                    valid: isIRMValid,
                    error: isIRMValid ? '' : 'Please select an item receipt method'
                }
            }
        });
    }

    disableInvalidIrm = (saleIrm) => {
        let invalidIrm = [];
        let irm = saleIrm
        if (typeof saleIrm === 'string') {
            irm = JSON.parse(saleIrm);
        }
            const keys = Object.keys(irm);
            keys.forEach(key => {
                if (!irm[key]) {
                    invalidIrm.push(key)
                }
            });
            let valuecheck = this.state.settings.itemreceiptmethod.value;
            const irmvalue= Object.keys(valuecheck).filter(key => valuecheck[key] === true);
            if(irmvalue){
                invalidIrm = invalidIrm.filter(irmName => !irmvalue.includes(irmName));
            }

        this.setState({
            invalidIrm: invalidIrm.length === 3 ? [] : invalidIrm
        });
    };

    setItemReceiptMethod = (irm) => {
        // IRM handling
        let currentIRM = {"pickup": false, "delivery": false, "shipping": false};
        
        if (typeof irm === 'string') {
            currentIRM = JSON.parse(irm);
        }
        
        this.setState({
            ...this.state,
            settings: {
                ...this.state.settings,
                itemreceiptmethod: {...this.state.settings.itemreceiptmethod, value: currentIRM},
            },
        }, () => {
            this.validateIRM();
        });
    };
    // checkpoint input field enable & disable logics
    setCheckPoint = (flag) => { 
        setTimeout(() => {
            this.setState({
                checkpointInput : flag
            })
            if(!flag) {
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        settings: {
                            ...this.state.settings,
                            salestaffcheckpointid: {...this.state.settings.salestaffcheckpointid, error: '', valid: true },
                            salestaffcheckpoint: { ...this.state.settings.salestaffcheckpoint, value: '', valid: true, error: '' },
                        },
                    })
                });
            }
        });
    }

    // check point input error handling
    handleCheckPointInput = (flag) => {
        if(flag === 'QM'){
            setTimeout(() => {
                this.setState({
                    ...this.state,
                    settings: {
                        ...this.state.settings,
                        salestaffcheckpoint: { ...this.state.settings.salestaffcheckpoint, value: '', error: 'please enter value', valid: false, validators: [Validators.required()] },
                    },
                })
            });
        }
    }
    

    inputChangeaddress = (event) => {
        
        let inputError = '';
        let eventValue = event.target.value;

    }
    checkEndTimeDisbale = () => {
        const endTimeLocal = moment(this.state.settings.endtime.value).format("YYYY-MM-DD HH:mm:ss");
        if(!this.edit){
            if(moment.tz(endTimeLocal, this.state.tempTimeZone).utc().isSameOrBefore(moment.utc()) && this.state.itemlist.length > 0){
                return true
            }
            else{
                return false
            }
        }
       
    }
    /*called changes in input */
    inputChange = (event) => {
        
   
        let inputError = '';
        let eventValue 
        if (event.target.name === 'ispublic') {
            eventValue = !this.state.detail.ispublic.value;
        }
        if ((event.target.name !== 'starttime' && event.target.name !== 'endtime' && event.target.name !== 'pickuptime')) {
            eventValue = event.target.value.replace(/^\s+/, '');
        }
        else{
            eventValue = event.target.value
        }
        if (event.target.name === 'contactmobile')
            eventValue = commonMobileNumberFormat(event.target.value, this.state.detail.contactmobile.value);
        if (event.target.name === 'zipcode') {
            if (isNaN(Number(eventValue))) {
                eventValue = '';
            }
            if (eventValue.includes(" ")) {
                eventValue = eventValue.replace(/\s/g, "");
            }
        }
        if (event.target.name === 'applytaxonbp') {
            eventValue = Boolean(event.target.checked);
        }
        if (event.target.name === 'closeduration') {
            if (eventValue) {
                eventValue = Number(eventValue);
                if (isNaN(eventValue))
                    eventValue = '';
            }
            else
                eventValue = '';
        }
        if(event.target.name === 'city'){
            eventValue = event.target.value.replace(/[^a-zA-Z ]/g, "");
            this.checkStateAndCity(this.state.detail.zipcode.value, this.state.detail.state.value, eventValue);
            // if(this.state.cityDropdownValue.length > 0 && !this.state.showCityDropdown){
            //     this.setState({
            //         showCityDropdown: true
            //     })
            // }
        }

        if (event.target.name === 'state'){
            // this.getCity('state');
            this.checkStateAndCity(this.state.detail.zipcode.value, event.target.value, this.state.detail.city.value);
        }

        if (event.target.name === 'buyerspremium' || event.target.name === 'tax') {
                
                if (event.target.value.includes('.') && event.target.value.split('.')[1].length > 3) {
                    return;
                }
                if (this.timeoutInterval[event.target.name]) {
                    clearTimeout(this.timeoutInterval[event.target.name]);
                }

                eventValue = eventValue.replace(/[^0-9.]/g, '');
                this.timeoutInterval[event.target.name] = setTimeout(() => {
                    if (event.target.value) {
                        var formattedValue = parseFloat(event.target.value).toFixed(3)
        
                        this.setState({
                            ...this.state,
                            [step[this.state.currentPage]]: {
                                ...this.state[step[this.state.currentPage]],
                                [event.target.name]: {
                                    ...this.state[step[this.state.currentPage]][event.target.name],
                                    value: formattedValue,
                                    error: inputError,
                                    valid: !Boolean(inputError),
                                }
                            }

                        })
        
                    }
                }, 1000);        
        }

        /* check for validation */
        if (Object.keys(this.state[step[this.state.currentPage]][event.target.name]).includes('validators')) {
            for (let validator of this.state[step[this.state.currentPage]][event.target.name].validators) {
                inputError = validator(eventValue);
                if (inputError) break;
            }
        }


        if (event.target.name === 'address1') {
    
          
            if (eventValue.toString().length > 45)
                inputError = 'Maximum 45 characters';
            else if (eventValue.toString().length >= 46)
                inputError = 'Maximum 45 characters';
            else if (eventValue.toString().length >= 5 && parseInt(eventValue) === 0)
                eventValue = 0
        }

        if (event.target.name === 'address2') {
    
            
            if (eventValue.toString().length > 45)
                inputError = 'Maximum 45 characters';
            else if (eventValue.toString().length >= 46)
                inputError = 'Maximum 45 characters';
            else if (eventValue.toString().length >= 5 && parseInt(eventValue) === 0)
                eventValue = 0
        }


        if (event.target.name === 'zipcode') {
            setTimeout(() => {
                this.setState({
                    ...this.state,
                    detail: {
                        ...this.state.detail,
                        // city: { ...this.state.detail.city, value: '', valid: false, error: '' },
                        state: { ...this.state.detail.state, value: '', valid: false }
                    },
                })
            });
            if (eventValue.toString().length < 5)
                inputError = 'Minimum 5 digits';
            else if (eventValue.toString().length >= 6)
                inputError = 'Maximum 5 digits';
            else if (eventValue.toString().length >= 5 && parseInt(eventValue) === 0)
                eventValue = 0
        }
        // if (event.target.name === 'pickuptime') {
        //     if (new Date(this.state.settings.endtime.value).getDate() == new Date(event.target.value).getDate() && new Date(this.state.settings.endtime.value).getMonth() == new Date(event.target.value).getMonth()) {
        //         let startdate = new Date(this.state.settings.endtime.value).setMinutes(new Date(this.state.settings.endtime.value).getMinutes() + 15);
        //         setTimeout(() => {
        //             this.setState({
        //                 pickupminTime: startdate
        //             })
                    
        //         }, 1000);
               
        //     }
        //     else {
        //         setTimeout(() => {
        //             let pickupdate = new Date(moment(event.target.value)).setHours(0, 0, 0)
        //             this.setState({
        //                 pickupminTime: pickupdate
        //             })
                    
        //         }, 1000);
             
        //     }
        // }

        if ((event.target.name === 'starttime' || event.target.name === 'endtime' || event.target.name === 'pickuptime')) {
            if (new Date(eventValue).getDate() === new Date(this.state.currentDate.format('YYYY/MM/DD hh:mm A')).getDate() && new Date(eventValue).getMonth() === new Date(this.state.currentDate.format('YYYY/MM/DD hh:mm A')).getMonth() && new Date(eventValue).getFullYear() === new Date(this.state.currentDate.format('YYYY/MM/DD hh:mm A')).getFullYear() && moment(eventValue).hours() < this.state.currentDate.hours() && moment(eventValue).minutes() < this.state.currentDate.minutes()) {
                // eventValue = new Date(this.state.currentDate.format('YYYY/MM/DD hh:mm A')).setHours(this.state.currentDate.hours(), this.state.currentDate.minutes());
               
                let currentDate = new Date(moment().tz(this.state.zonename).format('YYYY/MM/DD hh:mm A'));
                let minutes = currentDate.getMinutes();
                let roundedMinutes = Math.ceil(minutes / 15) * 15;

                if (roundedMinutes === 60) {
                    currentDate.setHours(currentDate.getHours() + 1, 0, 0, 0);
                } else {
                    currentDate.setMinutes(roundedMinutes, 0, 0);
                }

                eventValue = currentDate;
            }
            if (isNaN(eventValue)) {
                eventValue = '';
                inputError = 'Please enter value';
            }
            if (!this.edit) {
                if (eventValue && new Date(eventValue) < new Date(this.state.currentDate.format('YYYY/MM/DD hh:mm A'))) {
                    // eventValue = new Date(this.state.currentDate.format('YYYY/MM/DD hh:mm A'));

                    let currentDate = new Date(moment().tz(this.state.zonename).format('YYYY/MM/DD hh:mm A'));
                    let minutes = currentDate.getMinutes();
                    let roundedMinutes = Math.ceil(minutes / 15) * 15;

                    if (roundedMinutes === 60) {
                        currentDate.setHours(currentDate.getHours() + 1, 0, 0, 0);
                    } else {
                        currentDate.setMinutes(roundedMinutes, 0, 0);
                    }

                    eventValue = currentDate;
                }
            }
            if( event.target.name === 'endtime' && new Date(event.target.value).setHours(0,0,0) >=  new Date(this.state.settings.pickuptime.value).setHours(0, 0, 0, 0) && this.state.settings.pickuptime.value ){
                
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        settings: {
                            ...this.state.settings,
                            pickuptime: {
                                value: this.state.settings.pickuptime.value,
                                error: "Pickup date should be greater than end date",
                                valid: false
                            }
                        }
                    })
                    
                }, );
            } 
            else if( event.target.name === 'endtime' && new Date(event.target.value).setHours(0,0,0) < this.state.settings.pickuptime.value && this.state.settings.pickuptime.value ){
                inputError = '';
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        settings: {
                            ...this.state.settings,
                            pickuptime: {
                                value: this.state.settings.pickuptime.value,
                                error: "",
                                valid: true
                            }
                        }
                    })
                    
                }, );
               
            }
        }

        this.setState({
            ...this.state,
            [step[this.state.currentPage]]: {
                ...this.state[step[this.state.currentPage]],
                [event.target.name]: {
                    ...this.state[step[this.state.currentPage]][event.target.name],
                    value: eventValue,
                    error: inputError,
                    valid: !Boolean(inputError),
                }
            },
            // formErrorMessage: inputError
        }, () => {

            /* get contact name for location */
            if (event.target.name === 'locationid') {
                this.getTimezoneContactName(false, "location");
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        detail: {
                            ...this.state.detail,
                            franchiseid: {
                                ...this.state.detail.franchiseid,
                                value:  '',
                            }
                        },
                    })
                    
                }, 10);
            }
            
            if (event.target.name === 'starttime' || event.target.name === 'endtime') {
                if (this.state.settings.endtime.value)
                        this.checkEndTime();
                this.getminTime(event);
                    setTimeout(() => {
                     this.setState({
                        ...this.state,
                        tempTimeZone:this.state.zonename,
                        tempStarttime:  this.edit ? '' : new Date(moment(this.state.settings.starttime.value, 'YYYY/MM/DD hh:mm A')),
                        tempEndtime:  this.edit ? '' : new Date(moment(this.state.settings.endtime.value, 'YYYY/MM/DD hh:mm A')),
                    })
                });
          

            }
            if (event.target.name === 'endtime' && event.target.value < this.state.settings.pickuptime.value) {

                this.setState({
                    ...this.state,
                    settings: {
                        ...this.state.settings,
                        pickuptime: {
                            value: this.state.settings.pickuptime.value,
                            error: ""
                        }
                    }
                })
            }
            if (event.target.name === 'pickuptime' && new Date(event.target.value).setHours(0,0,0) > new Date(this.state.settings.endtime.value).setHours(0,0,0)) {
                setTimeout(() => {
                this.setState({
                    ...this.state,
                    formErrorMessage: '',
                    settings: {
                        ...this.state.settings,
                        pickuptime: {
                            value: this.state.settings.pickuptime.value,
                            error: "",
                            valid: true
                        }
                    }
                })
            }, 10);
            }
               

            if(event.target.name === 'salestaffcheckpointid') {
                if(eventValue === 'QM') {
                    this.setCheckPoint(true)
                    this.handleCheckPointInput(eventValue)
                }
                else {    
                    this.setCheckPoint(false)
                }
            }

            if (event.target.name === 'zipcode' && eventValue.toString().length > 4 && eventValue.toString().length < 7)
                this.getStateCity();

            

            if (event.target.name === 'timezoneid') {
                this.isTimezoneChanged = true;
                this.calculateTimeZonetime(false);
                let zoneName = this.timezone.filter(x => x.id === Number(this.state.settings.timezoneid.value))[0];
                let mintime = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
                let minDate = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A'));
                
                setTimeout(() => {
                 
                    this.setState({
                        ...this.state,
                        minimumTime:mintime, 
                        minDate:minDate,
                        startDate: moment.tz(new Date(), this.state.tempTimeZone).tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A'),
                        timezoneChangeConfirm: false,
                        settings: {
                            ...this.state.settings,
                            starttime: {   value:  this.state.tempStarttime ? this.toTimeZone(this.state.tempStarttime,this.state.tempTimeZone, zoneName.zonename):'', valid: false, error: '', validators: [Validators.required()]},
                            endtime: {    value: this.state.tempEndtime ? this.toTimeZone(this.state.tempEndtime,this.state.tempTimeZone, zoneName.zonename):'', valid: false, error: '', validators: [Validators.required()] },
                            
                        },                   
                    }, () => {
                        this.checkEndTime();
                        if (!this.edit) {
                            let currentMinDate = new Date(moment().tz(this.state.zonename).format('YYYY-MM-DDThh:mm')).getDate();
                            let currentDate = new Date(moment().tz(this.state.zonename).format('YYYY-MM-DDThh:mm')).getTime();
                            let createDate = new Date(moment().tz(this.state.zonename).format('YYYY-MM-DDThh:mm')).getTime();
                            let startMillis = new Date(this.state.settings.endtime.value)
                            createDate = startMillis.getTime()
                            if (new Date(this.state.settings.starttime.value).getDate() === new Date(this.state.settings.endtime.value).getDate() &&
                                new Date(this.state.settings.starttime.value).getMonth() === new Date(this.state.settings.endtime.value).getMonth() && new Date(this.state.settings.starttime.value).getFullYear() === new Date(this.state.settings.endtime.value).getFullYear()) {
                                createDate = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
                            }
                             if (currentDate < new Date(this.state.settings.endtime.value).getTime()) {
                                createDate = new Date(createDate).setHours(0, 0, 0)
                            } else {
                                createDate = new Date(this.state.settings.endtime.value)
                            }
                            if (this.state.isSafari) {
                                createDate = moment(createDate)
                                currentDate = moment(currentDate)
                            }
                            
                            if (event.target.name === 'timezoneid')  {

                                if((new Date(this.state.settings.starttime.value).getDate() !== currentMinDate)) {
                                    createDate = new Date(this.state.settings.starttime.value).setHours(23, 59, 59);
                                }
                                else {
                                    createDate = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes());
                                }

                                if((new Date(this.state.settings.starttime.value).getDate() > currentMinDate)) {
                                    createDate = new Date(this.state.settings.starttime.value).setHours(0, 0, 0);
                                }
                            }
                         
                            setTimeout(() => {
                                this.setState({
                                    minimumTime: createDate,
                                    EndDateminTime: new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15),
                                    minDate: currentDate
                                });

                            }, 1000)


                        }
                       
                    })                   
                });

               
            }

            /* check form validity */
            if (inputError) {
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        [step[this.state.currentPage]]: {
                            ...this.state[step[this.state.currentPage]],
                            formValid: false
                        }
                    });
                });
            }
            else {
                this.checkFormValidity();
            }

            if (this.state.detail.formValid && this.state.settings.formValid) {
                this.setState({
                    ...this.state,
                    formValid: true
                });
            }
        });
        let fieldName = event.target.name
        if (["buyerspremium", "tax"].includes(fieldName)) {
            this.setState({ showEditMsg: true });
        }
    }

    /* check form validation */
    checkFormValidity = () => {
        let valid = true;
        let ignoreFormControls = ['formValid', 'viewModal', 'editModal', 'isTemplateData'];
        for (let control of Object.keys(this.state[step[this.state.currentPage]])) {
            if (!this.state[step[this.state.currentPage]][control].valid && !ignoreFormControls.includes(control)) {
                valid = false;
                break;
            }
        }
        let formError = this.state.saleStatus.message;
        if (valid)
            formError = this.state.saleStatus.message === 'Cannot save: please add the required fields in red above' ? '' : this.state.saleStatus.message;
        this.setState({
            ...this.state,
            [step[this.state.currentPage]]: {
                ...this.state[step[this.state.currentPage]],
                formValid: valid
            },
            saleStatus: {
                ...this.state.saleStatus,
                message: formError
            }
        });
    }

    /* Calculate time zone time */
    calculateTimeZonetime = (isGetData = false) => {
        let zoneName = this.timezone.filter(x => x.id === Number(this.state.settings.timezoneid.value))[0];
        let starttime = this.state.settings.starttime.value;
        let endtime = this.state.settings.endtime.value;
        let endmintime = null;
        let datenow = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD'));
        let mintime = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();

        if( (new Date(this.state.settings.starttime.value) < new Date(this.state.EndDateminTime)) &&
            (new Date(this.state.settings.starttime.value) !== new Date(this.state.EndDateminTime))){
            mintime = new Date(this.state.settings.starttime.value).setHours(23, 59, 59);
        }
      
       /*  if (new Date(this.state.settings.starttime.value) <= new Date(this.state.settings.endtime.value)) {
                        endmintime = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
                    } else {
                        //date = new Date(date).setHours(startMillis.getHours(), startMillis.getMinutes(), 0)
                       
                        endmintime = new Date(new Date(this.state.settings.starttime.value).getTime()).setHours(0, 0, 0)
                    } */
                    if(moment(new Date(this.state.settings.starttime.value)).format('YYYY/MM/DD') === moment().format('YYYY/MM/DD')){
                        mintime = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
                        
                    }
                    if(this.state.settings.starttime.value && moment(new Date(this.state.settings.starttime.value)).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD')){
                        mintime = new Date(this.state.settings.endtime.value).setHours(0, 0, 0);
                    }
                    if (new Date(moment(this.state.settings.starttime.value, 'YYYY/MM/DD')) === new Date(moment(this.state.settings.endtime.value, 'YYYY/MM/DD'))) {
                         
                        endmintime = new Date(moment(this.state.settings.starttime.value, 'YYYY/MM/DD hh:mm A').add(15, 'minutes').format('YYYY/MM/DD hh:mm A'));
                   
                    }
                  
                    if (new Date(this.state.settings.starttime.value) <= new Date(this.state.settings.endtime.value)) {
                        endmintime = new Date(this.state.settings.endtime.value).setHours(0, 0, 0);
                    }
                    
                    if (new Date(this.state.settings.endtime.value).getDate() === new Date(this.state.minDate).getDate() &&
                        new Date(this.state.settings.endtime.value).getMonth() === new Date(this.state.minDate).getMonth() &&
                        new Date(this.state.settings.endtime.value).getFullYear() === new Date(this.state.minDate).getFullYear()) {
                        endmintime = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A'));
                    }

                    if (new Date(this.state.settings.starttime.value).getDate() === new Date(this.state.settings.endtime.value).getDate() && 
                    new Date(this.state.settings.starttime.value).getMonth() === new Date(this.state.settings.endtime.value).getMonth() && new Date(this.state.settings.starttime.value).getFullYear() === new Date(this.state.settings.endtime.value).getFullYear()) 
                         {
                      
                             endmintime = new Date(moment(this.state.settings.starttime.value, 'YYYY/MM/DD hh:mm A').add(15, 'minutes').format('YYYY/MM/DD hh:mm A'));
                           
                        }
                        if (moment(new Date(this.state.settings.starttime.value)).format('YYYY/MM/DD') === moment().format('YYYY/MM/DD')) 
                         {
                      
                             endmintime = new Date(moment(this.state.settings.starttime.value, 'YYYY/MM/DD hh:mm A').add(15, 'minutes').format('YYYY/MM/DD hh:mm A'));
                           
                        }

                        if (new Date(this.state.settings.endtime.value) < new Date(this.state.minDate)) {
                                endmintime = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A'));
                        }  
                         
                        if (new Date(this.state.minDate).getDate() < new Date(this.state.settings.endtime.value).getDate()) {
                            endmintime = new Date(this.state.settings.endtime.value).setHours(0, 0, 0);
                        }
                       
                      
                        if (new Date(this.state.settings.endtime.value) < new Date(datenow) && 
                        new Date(this.state.settings.endtime.value).getDate() < new Date(datenow).getDate() ) {
                            endmintime = new Date(this.state.settings.endtime.value).setHours(23, 59, 59);
                        }
                        if(new Date(this.state.settings.endtime.value).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)){
                            endmintime = new Date(this.state.settings.endtime.value).setHours(23, 59, 59);
                        }
      
        setTimeout(() => {
            this.setState({
                zonename: zoneName.zonename,
                currentDate: moment().tz(zoneName.zonename),
                currentStartDate: isGetData ? moment().tz(zoneName.zonename).toDate() : this.state.currentStartDate,
                currentEndDate: isGetData ? moment().tz(zoneName.zonename).toDate() : this.state.currentEndDate,
                minimumTime:mintime,
                EndDateminTime:this.state.settings.starttime.value ? endmintime : mintime,
                startDate:moment.tz(new Date(), this.state.tempTimeZone).tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A'),
                minDate : new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')), 
                // minimumTime:new Date(moment.tz(new Date(), zoneName.zonename).tz(zoneName.zonename).format('YYYY-MM-DD hh:mm A')), // setting the minimum time based on the selected time zone
                settings: {
                    ...this.state.settings,
                    starttime: {
                        ...this.state.settings.starttime,
                        value: starttime
                    },
                    endtime: {
                        ...this.state.settings.endtime,
                        value: endtime,
                    }
                    
                }
            }, () => {

               if(!this.edit) this.checkEndTime();
                //this.getminTime();
            });
        });
    }


    getminTime = (eventValue) => {
        let zoneName = this.timezone.filter(x => x.id === Number(this.state.settings.timezoneid.value))[0]; 
        if (this.edit) {
            
            let createDate = new Date(moment().tz(this.state.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
            let currentDate = new Date(moment().tz(this.state.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
            let currentMillis = new Date(moment().tz(this.state.zonename).format('YYYY/MM/DD hh:mm A')).setHours(0, 0, 0, 0);
            
           
           let endmintime =   new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
            if (eventValue.target?.name === 'starttime' ) {
                let checkMillis = new Date(this.state.settings.starttime.value).setHours(0, 0, 0, 0)
                let startMillis = new Date(this.state.settings.starttime.value)
                createDate = startMillis.getTime()
                if (currentMillis == checkMillis) {
                    createDate = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
                }
                else if (currentDate < new Date(this.state.settings.starttime.value).getTime()) {
                    createDate = new Date(createDate).setHours(0, 0, 0)
                } 
                else if (new Date(currentDate).getTime() > new Date(this.state.settings.starttime.value).getTime()) {
                    createDate = new Date(createDate).setHours(23, 59, 59)
                } 
    
                else {
                     
                    let mintime = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
                    createDate = mintime
                }
                
                
                 if (new Date(this.state.settings.starttime.value).getDate() < new Date(this.state.settings.endtime.value).getDate()) {
                    // date = new Date(this.state.settings.endtime.value).getTime();
                    endmintime = new Date(this.state.settings.endtime.value).setHours(0, 0, 0)
                 } 
                 if (new Date(this.state.settings.starttime.value) < new Date(this.state.settings.endtime.value)) {
                    endmintime = new Date(this.state.settings.endtime.value).setHours(0, 0, 0)
                 } 
                 if (new Date(this.state.settings.starttime.value).getDate() === new Date(this.state.settings.endtime.value).getDate() && 
                    new Date(this.state.settings.starttime.value).getFullYear() === new Date(this.state.settings.endtime.value).getFullYear()) {
                    endmintime = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
                 } 
               
            
            setTimeout(() => {
                this.setState({
                    startDate: this.state.settings.starttime.value,
                    minimumTime: createDate,
                    minDate: currentDate,
                    EndDateminTime: endmintime,
                 });
            }, 500)
            }
            else {
                let checkMillis = new Date(this.state.settings.endtime.value).setHours(0, 0, 0, 0)
                let startMillis = new Date(this.state.settings.endtime.value)
                createDate = startMillis.getTime()
                let pickupdate = new Date()
                if (new Date(this.state.settings.starttime.value).getDate() === new Date(this.state.settings.endtime.value).getDate() && 
                new Date(this.state.settings.starttime.value).getMonth() === new Date(this.state.settings.endtime.value).getMonth() && new Date(this.state.settings.starttime.value).getFullYear() === new Date(this.state.settings.endtime.value).getFullYear()) {
                    // createDate = new Date(this.state.settings.endtime.value).getTime();
                    createDate = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
                }
                /* if (currentMillis === checkMillis) {
                     createDate = new Date(this.state.settings.endtime.value).getTime();
                    //createDate = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
                } */
                else if (new Date(currentDate).getTime() > new Date(this.state.settings.endtime.value).getTime()) {
                    createDate = new Date(createDate).setHours(23, 59, 59)
                } 

                else if (currentDate < new Date(this.state.settings.endtime.value).getTime()) {
                    createDate = new Date(createDate).setHours(0, 0, 0)
                } else {
                    createDate = new Date(this.state.settings.endtime.value)
                }

                setTimeout(() => {
                    this.setState({
                      
                        EndDateminTime: createDate,
                    });
                }, 500)
               
            }
           

        }
        else {
            try {


                let date = new Date(moment().tz(this.state.zonename).format('YYYY-MM-DDThh:mm')).getTime();
                let currentDate = new Date(moment().tz(this.state.zonename).format('YYYY-MM-DDThh:mm')).getTime();
                let currentMillis = new Date(moment().tz(this.state.zonename).format('YYYY-MM-DDThh:mm')).setHours(0, 0, 0, 0);

                let createDate = new Date(moment().tz(this.state.zonename).format('YYYY-MM-DDThh:mm')).getTime();
                let datenow = new Date(moment().tz(this.state.zonename).format('YYYY/MM/DD hh:mm A'));

                let endmintime = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
             
                if (eventValue.target.name === 'starttime') {
                    let checkMillis = new Date(this.state.settings.starttime.value).setHours(0, 0, 0, 0)
                let startMillis = new Date(this.state.settings.starttime.value)
                createDate = startMillis.getTime()
                
                if (currentMillis == checkMillis) {
                    
                    createDate = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
                }
                if (new Date() > new Date(eventValue?.target?.value)) {
                    createDate = new Date(createDate).setHours(23, 59, 59)
                } 
                  if (currentDate < new Date(this.state.settings.starttime.value).getTime()) {
                    createDate = new Date(createDate).setHours(0, 0, 0)
                } 
                if (new Date(eventValue?.target?.value).getDate() === datenow.getDate() && 
                new Date(eventValue?.target?.value).getMonth() === datenow.getMonth() && new Date(eventValue?.target?.value).getFullYear() === datenow.getFullYear()) {
                    createDate = new Date(moment().tz(zoneName.zonename).format('YYYY/MM/DD hh:mm A')).getTime();
                }
                 
         
                if (new Date(this.state.settings.starttime.value).getDate() === new Date(this.state.settings.endtime.value).getDate()) {
                    endmintime = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
                 } 
                
          
                 if (new Date(this.state.settings.starttime.value) > new Date(this.state.settings.endtime.value) &&
                    new Date(this.state.settings.starttime.value).getDate() > new Date(this.state.settings.endtime.value).getDate()) {
                    endmintime = new Date(this.state.settings.endtime.value).setHours(23, 59, 59);
                 } 
                 if (new Date(this.state.settings.starttime.value) < new Date(this.state.settings.endtime.value) &&
                    new Date(this.state.settings.starttime.value).getDate() > new Date(this.state.settings.endtime.value).getDate()) {
                    endmintime = new Date(this.state.settings.endtime.value).setHours(0, 0, 0);
                 }
                 if(new Date(this.state.settings.starttime.value).getMonth() < new Date(this.state.settings.endtime.value).getMonth() ||
                 new Date(this.state.settings.starttime.value).getDate() < new Date(this.state.settings.endtime.value).getDate() || 
                 new Date(this.state.settings.starttime.value).getFullYear() < new Date(this.state.settings.endtime.value).getFullYear()){
                    endmintime = new Date(this.state.settings.endtime.value).setHours(0, 0, 0);
                }
            setTimeout(() => {
                this.setState({
                    minimumTime: createDate,
                    minDate: currentDate,
                    EndDateminTime: endmintime,
                 });
            }, 500)
               
                }
                else { 

                    if(new Date(this.state.settings.starttime.value).getDate() < new Date(this.state.settings.endtime.value).getDate() || 
                    new Date(this.state.settings.starttime.value).getMonth() < new Date(this.state.settings.endtime.value).getMonth() ||
                    new Date(this.state.settings.starttime.value).getFullYear() < new Date(this.state.settings.endtime.value).getFullYear()){
                        createDate = new Date(this.state.settings.endtime.value).setHours(0, 0, 0)
                    }
                    if (new Date(this.state.settings.endtime.value).getDate() === new Date(this.state.minDate).getDate() && 
                    new Date(this.state.settings.endtime.value).getMonth() === new Date(this.state.minDate).getMonth() &&
                    new Date(this.state.settings.endtime.value).getFullYear() === new Date(this.state.minDate).getFullYear()) {
                        createDate = new Date(moment().tz(this.state.zonename).format('YYYY/MM/DD hh:mm A'));
                    }
                    if (new Date(this.state.settings.starttime.value).getDate() === new Date(this.state.settings.endtime.value).getDate() && new Date(this.state.settings.starttime.value).getTime() >= new Date(datenow).getTime()  &&
                    new Date(this.state.settings.starttime.value).getMonth() === new Date(this.state.settings.endtime.value).getMonth() && new Date(this.state.settings.starttime.value).getFullYear() === new Date(this.state.settings.endtime.value).getFullYear() ) {
                        // createDate = new Date(this.state.settings.endtime.value).getTime();
                        createDate = new Date(this.state.settings.starttime.value).setMinutes(new Date(this.state.settings.starttime.value).getMinutes() + 15);
                    }

               
    
                    if (this.state.isSafari) {
                        createDate = moment(createDate)
                        currentDate = moment(currentDate)
                    }
                   
                    setTimeout(() => {
                        this.setState({
                            EndDateminTime: createDate,
                            minDate: currentDate
                        });
    
                    }, 1000) 
                    
                }
                

              
         
            } catch (e) {
            }

        }
    }


     
    /* check end time if already exsists before starttime */
    checkEndTime = () => {
        let error = '';
        if(this.state.settings.endtime.value === ''){
            error = 'Please enter value';
        }
        else if (new Date(this.state.settings.starttime.value) > new Date(this.state.settings.endtime.value) || (new Date(this.state.settings.starttime.value).getDate() === new Date(this.state.settings.endtime.value).getDate() && new Date(this.state.settings.starttime.value).getFullYear() === new Date(this.state.settings.endtime.value).getFullYear() && new Date(this.state.settings.starttime.value).getMonth() === new Date(this.state.settings.endtime.value).getMonth() && new Date(this.state.settings.starttime.value).getHours() === new Date(this.state.settings.endtime.value).getHours() && new Date(this.state.settings.starttime.value).getMinutes() === new Date(this.state.settings.endtime.value).getMinutes())) {
            error = 'End time should be greater than start time';
        }
        else {
            error =  '';
        }
        
        setTimeout(() => {
            this.setState({
                settings: {
                    ...this.state.settings, 
                    endtime: {
                        ...this.state.settings.endtime,
                        error: this.isTimezoneChanged ? null : error,
                        valid: error!=='' ? false : true
                    }

                }
            }, () => {
                this.checkFormValidity();
                this.isTimezoneChanged = false;
            })
        })
    }


    /* get tempalate detail */
    templateDetails = async () => {
        this.setState({
            ...this.state,
            formLoading: true
        }, () => {
            if (this.state.currentPage === 1) {
                /* get default template list */
                let filter = [{ field: "locationid", value: this.state.detail.locationid.value, op: "=", join: "AND" }]
                axios.post(getSellerUrl(loctemplatelist), JSON.stringify({ filter: filter }), getSellerHeaders())
                    .then(response => {
                        if (response.status === 200) {
                            this.setTemplateData(response.data.data);
                            this.setState({
                                ...this.state,
                                formLoading: false,
                                currentPage: 2
                            });

                        }
                    })
                    .catch(error => {
                        this.setState({
                            ...this.state,
                            formLoading: false,
                            currentPage: 2,
                            // saleStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                        });
                    })
            }
        })
    }

    /*set template data when getting template list */
    setTemplateData = (templateData) => {
        try{
        const template = { 'shipping instruction': 'shippinginfo', 'payment instruction': 'paymentinfo', 'invoice message': 'invoicemessage', 't & c': 'termsandconditions' };
        if (templateData.length) {
            templateData.forEach(data => {
                let temp = {};
                if (data['locationid'] === Number(this.state.detail.locationid.value)) {
                    data['type'] = data['type'].toLowerCase();
                    temp[template[data['type']]] = data['content'];
                    this.templateData.push(temp);
                }
            })
            if (this.templateData.length) {
                this.templateData.forEach(temp => {
                    this.setState({
                        ...this.state,
                        settings: {
                            ...this.state.settings,
                            isTemplateData: true,
                            [Object.keys(temp)]: {
                                ...this.state.settings[Object.keys(temp)],
                                value: temp[Object.keys(temp)],
                                valid: temp[Object.keys(temp)].length ? true : false,
                            }
                        }
                    })
                })
            }
            else {
                Object.values(template).forEach(data => {
                    this.setState({
                        ...this.state,
                        settings: {
                            ...this.state.settings,
                            [data]: {
                                ...this.state.settings[data],
                                value: '',
                                valid: false
                            }
                        }
                    })
                })
            }
        }
        }catch(e){
             console?.clear()
        }
    }

    /* show template view */
    showViewModal = (modalName) => {
        this.viewModalName = modalName;
        this.setState({
            ...this.state,
            settings: {
                ...this.state.settings,
                viewModal: true
            }
        })
    }

    /* show template edit */
    showEditModal = (modalName) => {
        this.editModalName = modalName;
        this.templateEditValue = this.state.settings[this.editModalName] ? this.state.settings[this.editModalName].value && this.state.settings[this.editModalName].value !== '{}' ? JSON.parse(this.state.settings[this.editModalName].value)['body'] : '' : ''
        this.setState({
            ...this.state,
            settings: {
                ...this.state.settings,
                editModal: true
            }
        })
    }

    /* called when template input change */
    templateChange = (value) => {
        this.templateEditValue = value;
    }

    /* set template data */
    saveTemplateChange = () => {
        let templateValue = {};
        templateValue['body'] = this.templateEditValue ? this.templateEditValue : '';
        this.setState({
            ...this.state,
            settings: {
                ...this.state.settings,
                [this.editModalName]: {
                    ...this.state.settings[this.editModalName],
                    value: JSON.stringify(templateValue),
                    valid: this.templateEditValue ? this.templateEditValue === "<p><br></p>" ? false : true : false,
                    error: this.templateEditValue ? this.templateEditValue === "<p><br></p>" ? 'Please enter value' : '' : 'Please enter value'
                },
                editModal: false
            }
        }, () => {
            this.checkFormValidity();
            this.templateEditValue = '';
        })
    }

    /* called when submit button clicked */
    checkFieldValidations = () => {
         
        this.saveIfValid();
      
        
        
    }
    
    saveIfValid(){
        let valid = true;
        let inputError = '';
        let stateData = this.state[step[this.state.currentPage]];
        let template = ['termsandconditions', 'paymentinfo', 'shippinginfo', 'invoicemessage'];
       
        

        for (let control of Object.keys(stateData)) {
            if (control === 'itemreceiptmethod' && !stateData[control].valid) {
                valid = false;
                break;
            } 
            if (control === 'pickuptime' && !stateData[control].valid) {
                valid = false;
                break;
            } 

            else if (Object.keys(stateData[control]).includes('validators') && !stateData[control].valid) {
                if (!template.includes(control)) {
                   
                    for (let validator of stateData[control].validators) {
                        inputError = (validator(stateData[control].value) == '') ? stateData[control].error : validator(stateData[control].value);
                        if (inputError) {
                            valid = false;
                            break;
                        }
                         
                    }

               
                
                }
                else {
                    valid = false;
                    inputError = 'Please enter value';
                }
                stateData[control]['error'] = inputError;
            }
             
            
             if(Object.keys(stateData[control]) && !stateData[control].valid){
                if (!template.includes(control)) {
                    if(control=='endtime'){
                        inputError = stateData[control].error;
                        if (inputError || stateData['formValid'] === false) {
                            valid = false;
                            
                        }
                    } 
                }
            } 
        }
       // if (stateData?.endtime) { valid = stateData?.endtime?.valid ? stateData?.endtime?.valid : false; }
        //valid = stateData.starttime.valid ? stateData.starttime.valid : false;
        stateData['formValid'] = valid;
        
        setTimeout(() => {
            this.setState({
                ...this.state,
                [step[this.state.currentPage]]: stateData,
                saleStatus: { show: !valid, type: !valid ? 'danger' : '', message: !valid ? 'Cannot save: please add the required fields in red above' : '' }
            }, async () => {
                if (this.state[step[this.state.currentPage]].formValid) {
                    if (this.state.currentPage === 1) {
                        if (this.edit && !this.state.settings.isTemplateData) {
                            await this.templateDetails();
                        }
                        else if (!this.edit) {
                            this.submitForm(true);
                        }
                        else
                            this.setState({ currentPage: 2 });
                    }
                    else {
                        if (this.edit)
                            this.setState({ showConfirmModal: true })
                        else {
                            if (this.state.currentPage === 2 && (this.state.showEditMsg)) {
                                this.setState({ showUpdateModal: true });
                            }
                            else
                                this.submitForm(true);
                        }
                    }

                }
            });
        });
    }
    camelize = (str) => {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return word.toUpperCase();
        }).replace(/\s+/g, ' ');
    }
    /* called when settings form completed and clicked */
    submitForm = async (isNavigateMedia) => {
        try {
            let checkpointMessage = this.state.checkpointList.filter(x => x.id === this.state.settings.salestaffcheckpointid.value);
            let checkpointMessagePayload = checkpointMessage[0]?.question ? checkpointMessage[0]?.question : ''
            let data = {};
            let formKeys = [];
            this.setState(this.state);
            this.setState({ showConfirmModal: false, loading: true, showUpdateModal: false });
            formKeys = Object.keys(this.state);
            formKeys.forEach(control => {
                if (control !== 'formValid' && control !== 'currentPage' && control !== 'media' && control !== 'saleid' && control !== 'minimumTime' && control !== 'minDate' && control !=='tempStarttime' &&
                control !== "tempEndtime" &&
                control !== "tempTimeZone" && control != "EndDateminTime" && control != "pickupDateWithoutFormat" && control != "itemMedia" && control != "processSaleImage" && control != "processItemImageIndex" ) {
                    Object.entries(this.state[control]).forEach(([key, value]) => data[key] = value['value']);
                }
            })
            delete data['formValid'];
            delete data['modal'];
            /* delete ['editModal'];
            delete ['viewModal'] */
            data['isactive'] = 1;
            data['saletypeid'] = 1;
            data['duration'] = null
            data['staggeredTime'] = null;
            data['addresstype'] = "Primary";
            data['country'] = "USA";
            data['city'] = this.camelize(data['city']);
            data['status'] = this.state.status;
            // let startDate = new Date(data['starttime']);
            data['starttime'] = moment(new Date(data['starttime'])).format("YYYY-MM-DD HH:mm:ss");
            data['endtime'] = moment(new Date(data['endtime'])).format("YYYY-MM-DD HH:mm:ss");
            let template = { content: {} };
            template['content'] = JSON.parse(data['termsandconditions']);
            data['termsandconditions'] = template;
            template = { content: {} };
            template['content'] = JSON.parse(data['invoicemessage']);
            data['invoicemessage'] = template;
            template = { content: {} };
            template['content'] = JSON.parse(data['shippinginfo']);
            data['shippinginfo'] = template;
            template = { content: {} };
            template['content'] = JSON.parse(data['paymentinfo']);
            data['paymentinfo'] = template;
            data['buyerspremium'] = data['buyerspremium'];
            data['applytaxonbp'] = this.state.settings.applytaxonbp.value ? 1 : 0;
            data['isshippable'] = this.state.settings.isshippable.value || !this.state.locationPickup ? 1 : 0;
            data['tax'] = data['tax'];
            data['contactname'] = this.state.detail.contactname.value
         
            data['saleitemreceiptmethod'] = this.state.settings.itemreceiptmethod.value;

            data['salestaffcheckpoint'] = this.state.settings.salestaffcheckpointid.value === 'QM' ?  this.state.settings.salestaffcheckpoint.value : checkpointMessagePayload
            data['pickuptime'] = data['pickuptime'] ? moment(new Date(data['pickuptime']).setHours(0,0,0)).format("YYYY-MM-DD HH:mm:ss") : null;

            if (this.edit) {
                await axios.post(getSellerUrl(saleadd), JSON.stringify({ data: data }), getSellerHeaders())
                    .then(response => {
                        if (response.status === 200) {
                            // toast.success('Successful');
                            this.setState({
                                ...this.state,
                                loading: false,
                                saleStatus: { show: true, type: 'success', message: 'Saved' }
                            });                           
                            if (isNavigateMedia) {
                                setTimeout(() => {
                                    this.setState({
                                        ...this.state,
                                        currentPage: 3,
                                        saleid: response.data.data[0]['id'],
                                        saleStatus: { show: false, type: '', message: '' }
                                    }, () => this.scrollToTop());
                                }, 3000);
                            }
                            else{
                                setTimeout(() => { this.props.history.push({ pathname: '/sales', state: this.props.location.state }) }, 3000);
                            }

                        }
                    })
                    .catch(error => {
                        if(error.response?.status == 401 || error.response?.status == 404) {
                            this.setState({
                                errorpageredirect: true,
                                errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                            })
                        }
                        this.setState({
                            loading: false,
                            showConfirmModal: false,
                            saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                        });
                        // toast.error(error.response.data['message']);

                    })
            }
            else {
           /*  this.state.tempStarttime = this.state.settings.starttime.value;
            this.state.tempEndtime = this.state.settings.endtime.value;
            */ let zone = this.timezone.filter(x => x.id === Number(this.state.settings.timezoneid.value))[0];
                this.state.tempTimeZone = zone.zoneName;
                data['id'] = this.state.saleid;
                await axios.put(getSellerUrl(saleupdate), JSON.stringify({ data: data }), getSellerHeaders())
                    .then(response => {
                        if (response.status === 200) {
                            let res =  isNavigateMedia ? '' :  {loading: false,
                            saleStatus: { show: true, type: 'success', message: 'Saved' }}

                            this.setState({
                                ...this.state,
                                res
                                },()=> {
                                setTimeout(() => {
                                    this.submitImage();
                                    // this.props.history.push({ pathname: '/sales', state: this.props.location.state });
                                }, 3000);
                            });
                          
                        }
                    })
                    .catch(error => {
                        if(error.response?.status == 401 || error.response?.status == 404) {
                            this.setState({
                                errorpageredirect: true,
                                errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                            })
                        } 
                        this.setState({
                            loading: false,
                            showConfirmModal: false,
                            saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                        });
                    })
            }
        } catch (e) {
            this.setState({
                loading: false
            })
            console?.clear()
        }
    }

    restoreState = () => {
        this.setState({ 
            ...this.state,
            settings: {
                ...this.state.settings,
                tax: {
                    ...this.state.settings.tax,
                    value: this.state.restoreTax,
                },
                buyerspremium: {
                    ...this.state.settings.buyerspremium,
                    value: this.state.restoreBuyerspremium,
                },
                itemreceiptmethod: {
                    ...this.state.settings.itemreceiptmethod,
                    value: this.state.restoreIrm,
                },
               
            },
            showUpdateModal: false,
        })
    }

    /*save banner & profile image */
    submitImage = async () => {
        try{
        let saleAddImage = [];
        let saleUpdateImage = [];
        this.setState({ loading: true });

        let itemImageData = this.state.itemMedia.map(img => img.value || img.imgSrc);

        if ( this.state.media.profile.value || (itemImageData.some(item => item !== null) && itemImageData.length > 0) ) {
            let data = {
                saleid: this.state.saleid,
                name: 'profile',
                type: 'image',
                image: this.state.media.profile.value ? this.state.media.profile.value : this.state.media.profile.imgSrc,
                itemimageurl: itemImageData
            };
            // if (this.edit) {
            //     saleAddImage.push(data);
            // }
            // else {
                if (this.imageData['profile']) {
                    data['id'] = this.imageData['profile'];
                    saleUpdateImage.push(data);
                } else {
                    saleAddImage.push(data);
                }
            // }
        }

        if ((this.edit && !this.state.media.ismedia) || saleAddImage.length) {
            await axios.post(getSellerUrl(saleimageadd), JSON.stringify({ data: saleAddImage }), getSellerHeaders())
                .then(response => {
                    if (response.data.data.length) {
                        this.setState({
                            loading: false,
                            saleStatus: { show: true, type: 'success', message: 'Saved' }
                        });
                    }
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        showConfirmModal: false,
                        saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                    });
                })
        }
        if (!this.edit && saleUpdateImage.length) {
            await axios.put(getSellerUrl(saleimageupdate), JSON.stringify({ data: saleUpdateImage }), getSellerHeaders())
                .then(response => {
                    if (response.data.data.length) {
                        this.setState({
                            loading: false,
                            saleStatus: { show: true, type: 'success', message: 'Saved' }
                        }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        saleStatus: { show: false, type: '', message: '' }
                                    });
                                    this.getSaleImages(false);
                                }, 3000);
                            });
                    }
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        showConfirmModal: false,
                        saleStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                    });
                })
        }
        else if (!this.edit && !saleUpdateImage.length) {
            this.setState({
                loading: false,
                showConfirmModal: false,
                saleStatus: { show: true, type: 'success', message: 'Saved' }
            }, () => {
                setTimeout(() => {
                    this.setState({
                        saleStatus: { show: false, type: '', message: '' }
                    });
                    this.getSaleImages(false);
                }, 3000);
            });
        }
        }catch(e){
             console?.clear()
        }
        setTimeout(()=>{
            this.props.history.push({ pathname: '/sales', state: this.props.location.state }) 
        }, 2000)
    }

    uploadBannerImage = () => {
        document.getElementById('img-banner').click();
    }

    uploadProfileImage = () => {
        document.getElementById('img-profile').click();
    }

    uploadItemImage = (id) => {
        document.getElementById(id).click();
    }

    changeImage = async (event, index) => {
        this.currentImage = event.target.name;
        const MAX_FILE_SIZE = 7.5 * 1024 * 1024; // 7.5MB
        const FILE_SIZE_ERROR = 'Sorry failed to upload. Use a file of less than 7.5mb.';

        if (this.currentImage === 'banner') {
            this.imageEditorDefaults = this.bannerEditorDefaults;

            // if we provide common setstate it can trigger modal box before updaing the configuration, 
            // so setstate is provided twice, here and in profile (else part)
            const file = new FileReader();
            file.onloadend = (fileEvent) => {
                const image = new Image();
                image.onload = () => {
                    if (image.width < 1200) {
                        this.bannerEditorDefaults['previewUpscale'] = true;
                        this.bannerEditorDefaults['cropAutoCenterImageSelectionTimeout'] = 1;
                    }
                    this.setState({
                        ...this.state,
                        media: {
                            ...this.state.media,
                            [event.target.name]: {
                                ...this.state.media[event.target.name],
                                tempImg: URL.createObjectURL(event.target.files[0])
                            },
                            modal: true
                        }
                    });

                    // reset input to upload same image
                    event.target.value = '';
                }

                /* load the base64 to get image height and width */
                image.src = fileEvent.target.result;
                 image.onerror = (err) => {
                this.setState({ setSaleImageErrorMessage: FILE_SIZE_ERROR });
                setTimeout(() => this.setState({ setSaleImageErrorMessage: '' }), 5000);
                event.target.value = '';
            };
            };

            /* load the image to get base64 */
            file.readAsDataURL(event.target.files[0]);
        } else if (this.currentImage === 'profile') {
            this.imageEditorDefaults = this.profileEditorDefaults;
            
            let uploadedFile = event.target.files[0];
            if (!uploadedFile) return;

            let mimetype = await FileType.fromBlob(uploadedFile);

            if ( !IMAGE_TYPES.includes(uploadedFile.type || mimetype.mime) ) {
                this.setState({
                    setSaleImageErrorMessage: "This file is not supported."
                });
                setTimeout(() => {
                    this.setState({
                        setSaleImageErrorMessage: ""
                    });
                }, 5000);
                event.target.value = '';
                return;
            }
             if (uploadedFile.size > MAX_FILE_SIZE) {
                this.setState({ setSaleImageErrorMessage: FILE_SIZE_ERROR });
                setTimeout(() => {
                    this.setState({ setSaleImageErrorMessage: '' });
                }, 5000);
                event.target.value = '';
                return;
            }

            let tempImg = URL.createObjectURL(uploadedFile);

            if (mimetype?.mime === "image/heic" || mimetype?.mime === "image/heif" ) {
                this.setState({
                    processSaleImage: true
                });
                let blob = await heic2any({
                    blob: uploadedFile,
                    toType: 'image/jpeg',
                    quality: 0.5
                });
                tempImg = URL.createObjectURL(blob);
                this.setState({
                    processSaleImage: false
                });
            }
            
            let img = new Image();
            img.src = tempImg;

              img.onerror = (err) => {
                this.setState({ setSaleImageErrorMessage: FILE_SIZE_ERROR });
                setTimeout(() => this.setState({ setSaleImageErrorMessage: '' }), 5000);
                event.target.value = '';
            };

            img.onload = async () => {
                if (img.width < 600 || img.height < 400) {
                     this.setState({
                        setSaleImageErrorMessage: "Please upload image with minimum size of 600W x 400H pixels."
                    });
                    setTimeout(() => {
                        this.setState({
                            setSaleImageErrorMessage: ""
                        });
                    }, 5000);
                    URL.revokeObjectURL(tempImg);
                    event.target.value = '';
                    return;
                }

                this.setState({
                    ...this.state,
                    media: {
                        ...this.state.media,
                        [event.target.name]: {
                            ...this.state.media[event.target.name],
                            tempImg: tempImg
                        },
                        modal: true
                    }
                });

                // reset input to upload same image
                event.target.value = '';
            };
        } else {
            this.imageEditorDefaults = this.itemEditorDefaults;

            let uploadedFile = event.target.files[0];
            if (!uploadedFile) return;

            if (uploadedFile.size > MAX_FILE_SIZE) {
                this.setState({ setItemImageErrorMessage: FILE_SIZE_ERROR });
                setTimeout(() => {
                    this.setState({ setItemImageErrorMessage: '' });
                }, 5000);
                event.target.value = '';
                return;
            }

            let mimetype = await FileType.fromBlob(uploadedFile);

            if ( !IMAGE_TYPES.includes(uploadedFile.type || mimetype.mime) ) {
                this.setState({
                    setItemImageErrorMessage: "This file is not supported."
                });
                setTimeout(() => {
                    this.setState({
                        setItemImageErrorMessage: ""
                    });
                }, 5000);
                event.target.value = '';
                return;
            }

            let tempImg = URL.createObjectURL(uploadedFile);

            if (mimetype?.mime === "image/heic" || mimetype?.mime === "image/heif") {
                this.setState({
                    processItemImageIndex: index
                });
                let blob = await heic2any({
                    blob: uploadedFile,
                    toType: 'image/jpeg',
                    quality: 0.5
                });
                tempImg = URL.createObjectURL(blob);
                this.setState({
                    processItemImageIndex: null
                });
            }
            
            let img = new Image();
            img.src = tempImg;

            img.onload = async () => {
                if (img.width < 400 || img.height < 400) {
                     this.setState({
                        setItemImageErrorMessage: "Please upload image with minimum size of 400W x 400H pixels."
                    });
                    setTimeout(() => {
                        this.setState({
                            setItemImageErrorMessage: ""
                        });
                    }, 5000);
                    URL.revokeObjectURL(tempImg);
                    event.target.value = '';
                    return;
                }

                const updatedItem = [...this.state.itemMedia];
                updatedItem[index] = {
                    ...updatedItem[index],
                    tempImg
                };
                this.imageIndex = index;
                this.setState({
                    ...this.state,
                    itemMedia: updatedItem,
                    media: {
                        ...this.state.media,
                        modal: true
                    }
                });

                // reset input to upload same image
                event.target.value = '';
            }; 
            img.onerror = (err) => {
                this.setState({ setItemImageErrorMessage: FILE_SIZE_ERROR });
                setTimeout(() => {
                    this.setState({ setItemImageErrorMessage: '' });
                }, 5000);
                event.target.value = '';
            }; 
            
        }
    }

    setImage = (output) => {
        try{
            if(this.currentImage == "item") {
                const updatedItem = [...this.state.itemMedia];
                updatedItem[this.imageIndex] = {
                    ...updatedItem[this.imageIndex],
                    imgSrc: URL.createObjectURL(output.dest)
                };
                 this.setState({
                    ...this.state,
                    itemMedia: updatedItem,
                    media: {
                        ...this.state.media,
                        modal: false
                    }
                });
            } else {
                this.setState({
                    ...this.state,
                    media: {
                        ...this.state.media,
                        [this.currentImage]: {
                            ...this.state.media[this.currentImage],
                            imgSrc: URL.createObjectURL(output.dest)
                        },
                        modal: false
                    }
                });
            }
        
            this.index = "";

            const file = output.dest;
            let render = new FileReader();
            render.onloadend = () => {
                const base64String = render.result.replace('data:', '').replace(/^.+,/, '');
                if(this.currentImage == "item") {
                    const updatedItem = [...this.state.itemMedia];
                    updatedItem[this.imageIndex] = {
                        ...updatedItem[this.imageIndex],
                        value: base64String
                    };
                     this.setState({
                        ...this.state,
                        itemMedia: updatedItem,
                    });
                } else {
                    this.setState({
                        ...this.state,
                        media: {
                            ...this.state.media,
                            [this.currentImage]: { ...this.state.media[this.currentImage], value: base64String }
                        }
                    })
                }
            };

            render.readAsDataURL(file);
    } catch(e) {
        console?.clear()
    }
    }

    cancelImage = () => {
        this.setState({
            media: {
                ...this.state.media,
                [this.currentImage]: {
                    ...this.state.media[this.currentImage],
                    tempImg: null
                },
                modal: false
            }
        });
    }

    textEditorOnShow = (event) => {
        this.textEditorRef?.focus();
    }

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    }

    askConfirmForTimezoneChange = (event) => {
        let eventValue = event.target.value;
        this.timezoneTemp = {
            target: {
                name: event.target.name,
                value: eventValue
            }
        };

        if (event.target.name === 'timezoneid') {
            let timezoneId = this.timezone.filter(x => x.zonename === this.state.locationDetails['timezone'])[0]['id'];
            if (timezoneId != eventValue) {
                this.setState({ timezoneChangeConfirm: true });
            } else {
                this.inputChange(event);
            }
        }
    }

    changeTimeZone = () => {
        
        this.inputChange(this.timezoneTemp);
    }

    calendarClose = () => {
        let endtime = moment(new Date(this.state.settings.endtime.value)).format("YYYY-MM-DD HH:mm:ss");
        // let prvsEndTime = moment(this.state.tempEndtime).format("YYYY-MM-DD HH:mm:ss");
        if(endtime) {
            axios.post(getSellerUrl(`${saleDateValidity}`), {data: {"saleid": this.state.saleid, "endtime": endtime, "timezonename": this.state.tempTimeZone}}, getSellerHeaders()).then(response => {
                if(response.data.data.length > 0){
                    this.setState({
                        saleEndTimeChangeConfirm: true
                    })
                }
            }).catch(error => {
            })
        }
    }

    checkStateAndCity = (zipcode, state, city) => {
        this.setState({
            cityStateIsValid: false
        })
        if (state != "" && city != "" && zipcode != "") {
            axios.post(getSellerUrl(`${stateCityCheck}`), { data: { "zipcode": zipcode, "state": state, "city": city } }, getSellerHeaders()).then(response => {
                this.setState({
                    stateCityError: "",
                    cityStateIsValid: true,
                    showCityDropdown: false
                })
            }).catch(error => {
                if (error.response.data.status === 400 || error.response.data.status == "failed") {
                    this.setState({
                        showCityDropdown: true,
                        stateCityError: this.errorMessage,
                        cityStateIsValid: false,
                        cityDropdownValue: error.response.data.error.data,
                    })
                }
            });
        }
    }

    setCityValue = (city) => {
        this.setState({
            detail: {
                ...this.state.detail,
                city: {
                    ...this.state.detail.city,
                    value: city,
                    error: '',
                    valid: true
                }
            },
            showCityDropdown: false
        }, () => {
            let valid = true;
            let ignoreFormControls = ['formValid', 'viewModal', 'editModal', 'isTemplateData'];
            for (let control of Object.keys(this.state[step[this.state.currentPage]])) {
                if (!this.state[step[this.state.currentPage]][control].valid && !ignoreFormControls.includes(control)) {
                    valid = false;
                    break;
                }
            }
            let formError = this.state.saleStatus.message;
            if (valid)
                formError = this.state.saleStatus.message === 'Cannot save: please add the required fields in red above' ? '' : this.state.saleStatus.message;
            this.setState({
                ...this.state,
                [step[this.state.currentPage]]: {
                    ...this.state[step[this.state.currentPage]],
                    formValid: valid
                },
                saleStatus: {
                    ...this.state.saleStatus,
                    message: formError
                }
            }, () => {
                this.checkStateAndCity(this.state.detail.zipcode.value, this.state.detail.state.value, city);
            });
        })
    }

    handleKeyDown = (event) => {
        const char = event.key;
        const controlKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Tab"
        ];
        if (controlKeys.includes(event.key)) {
        return; // allow navigation/edit keys
        }
        if (!quillAllowedRegexPattern.test(char)) {
          event.preventDefault();
        }
    };

    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Saleid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div className="sale-page" style={{ overflow: "auto", overflowY: "overlay", overflowX: "hidden" }}>
                <div id="backbutton" style={{ backgroundColor: "white", padding: "1%" }}>
                    <span className="clickable" onClick={() => { this.props.history.push({ pathname: '/sales', state: this.props.location.state }) }}>
                        <i className=" fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                        <span style={{ paddingLeft: "1em" }}>Back</span>
                    </span>
                    <span style={{ marginLeft: "0.5em", paddingLeft: "1em", borderLeft: "1px solid", color: "#A12142" }}>{this.edit ? 'Create New Sale' : 'Sale Edit'}</span>
                </div>

                <div className="sale-stepper">
                    <ul>
                        <li className="sale-step"><Button className={this.state.currentPage === 1 ? "sale-step-button sale-step-active" : "sale-step-button"} disabled={this.state.currentPage === 1 || !this.edit ? this.state.formLoading ? true : false : true} onClick={() => this.setStep(1)}><span className="sale-step-number">1</span><span className="sale-step-label">Detail</span></Button></li>
                        <li className="sale-step"><Button className={this.state.currentPage === 2 ? "sale-step-button sale-step-active" : "sale-step-button"} disabled={this.state.currentPage === 2 || !this.edit ? this.state.formLoading ? true : false : true} onClick={() => this.setStep(2)}><span className="sale-step-number">2</span><span className="sale-step-label">Settings</span></Button></li>
                        <li className="sale-step"><Button className={this.state.currentPage === 3 ? "sale-step-button sale-step-active" : "sale-step-button"} disabled={this.state.currentPage === 3 || !this.edit ? this.state.formLoading ? true : false : true} onClick={() => this.setStep(3)}><span className="sale-step-number">3</span><span className="sale-step-label">Media</span></Button></li>
                    </ul>
                </div>
                {this.state.currentPage !== 3 &&
                    <div className="sale-content mb-5">
                        {/* <ul className="d-flex container">
                            <li className="stepper"><Button className={this.state.currentPage === 1 ? "active" : ''} disabled={this.state.currentPage === 1 || !this.edit ? false : true} onClick={() => this.setStep(1)}><span className="numberCount">1</span>Detail</Button></li>
                            <li className="stepper"><Button className={this.state.currentPage === 2 ? "active" : ''} disabled={this.state.currentPage === 2 || !this.edit ? false : true} onClick={() => this.setStep(2)}><span className="numberCount">2</span>Settings</Button></li>
                            <li className="stepper"><Button className={this.state.currentPage === 3 ? "active" : ''} disabled={this.state.currentPage === 3 || !this.edit ? false : true} onClick={() => this.setStep(3)}><span className="numberCount">3</span>Media</Button></li>
                        </ul> */}
                        <Container className="sale-container mb-5">
                            {this.state.formLoading ?
                                <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                </div> :
                                <div className='mb-5'>
                                    {this.state.currentPage === 1 &&
                                        <div className="sale-card sale-detail-card">
                                            <h6 className="sale-title">Sale Details</h6>
                                            <Form>
                                                <div className="sale-field sale-field-location">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.locationid.error && this.state.detail.locationid.error.length ? <small className="error">{this.state.detail.locationid.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="locationid" name="locationid" value={this.state.detail.locationid.value} className="sale-select" placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                        <option disabled={true} value={""} selected>Select Location</option>
                                                        {this.locations.map((loc, index) =>
                                                            <option key={index} value={loc.id}>{loc.title}</option>
                                                        )}
                                                    </Form.Control>
                                                    <Form.Label htmlFor="locationid" className="sale-label required">Location</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-franchise">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.franchiseid.error && this.state.detail.franchiseid.error.length ? <small className="error">{this.state.detail.franchiseid.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="franchiseid" name="franchiseid"
                                                        value={this.state.franchisedetail.includes(this.state.detail.franchiseid.value)
                                                            ? this.state.detail.franchiseid.value
                                                            : ""
                                                        }
                                                        placeholder=" " required onChange={(event) => this.inputChange(event)}>

                                                        <option disabled={true} value={""}>Franchise ID</option>
                                                        {this.state.franchisedetail.map((id, index) =>
                                                            <option key={index} value={id}>{id}</option>
                                                        )}
                                                    </Form.Control>
                                                    <Form.Label htmlFor="franchiseid" className="sale-label">Franchise ID</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-phone">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.contactmobile.error && this.state.detail.contactmobile.error.length ? <small className="error">{this.state.detail.contactmobile.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{phoneCallIcon}</span>
                                                    <Form.Control type="text" id="contactmobile" name="contactmobile" value={this.state.detail.contactmobile.value} placeholder="Enter phone number" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="contactmobile" className="sale-label required">Contact Phone Number</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-email">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.contactemail.error && this.state.detail.contactemail.error.length ? <small className="error">{this.state.detail.contactemail.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{mailIcon}</span>
                                                    <Form.Control type="email" id="contactemail" name="contactemail" value={this.state.detail.contactemail.value} placeholder="Enter email address" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="contactemail" className="sale-label required">Contact Email</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-contact">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.contactname.error && this.state.detail.contactname.error.length ? <small className="error">{this.state.detail.contactname.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{userIcon}</span>
                                                    <Form.Control type="text" id="contactname" name="contactname" value={this.state.detail.contactname.value} placeholder="Enter contact name" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="contactname" className="sale-label required">Contact Name</Form.Label>
                                                </div>
                                                {/* <div>
                                                    <Form.Check id="ispublic" name="ispublic" checked={this.state.detail.ispublic.value} label="Is Not Public" onChange={(event) => this.inputChange(event)} />
                                                </div> */}
                                                <div className="sale-field sale-field-title">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.title.error && this.state.detail.title.error.length  ? <small className="error">{this.state.detail.title.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{tagIcon}</span>
                                                    <Form.Control type="text" id="title" name="title" value={this.state.detail.title.value} placeholder="Enter sale title" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="title" className="sale-label required">Sale Title</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-address">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.address1.error &&  this.state.detail.address1.error.length  && this.state.detail.address1.error.length < 45 ? <small className="error">{this.state.detail.address1.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{locationIcon}</span>
                                                    <Form.Control type="text" id="address1" name="address1" value={this.state.detail.address1.value} placeholder="Enter address line 1"  onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="address1" className="sale-label required">Sale Address 1</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-address">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.address2.error && this.state.detail.address2.error.length ? <small className="error">{this.state.detail.address2.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{locationIcon}</span>
                                                    <Form.Control type="text"  id="address2" name="address2" value={this.state.detail.address2.value} placeholder="Enter address line 2 (optional)" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="address2" className="sale-label">Sale Address 2</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-zip">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.zipcode.error && this.state.detail.zipcode.error.length ? <small className="error">{this.state.detail.zipcode.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{hashtagIcon}</span>
                                                    <Form.Control type="text" id="zipcode" name="zipcode" maxLength={5} value={this.state.detail.zipcode.value} placeholder="Enter zip code" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="zipcode" className="sale-label required">Zip</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-state">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.state.error && this.state.detail.state.error.length ? <small className="error">{this.state.detail.state.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="state" name="state" value={this.state.detail.state.value} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                        <option disabled={true} value={""} selected>Select State</option>
                                                        {this.statelist.map((state, index) =>
                                                            <option key={index} value={state.state} >{state.state}</option>
                                                        )}
                                                    </Form.Control>
                                                    <Form.Label htmlFor="state" className="sale-label required">State</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-city">
                                                    <div className="text">
                                                        {
                                                           this.state.detail.city.error && this.state.detail.city.error.length ? <small className="error">{this.state.detail.city.error}</small> : this.state.stateCityError ? <small className='text-danger' style={{ margin: "0 25px" }}>{this.state.stateCityError}</small> : null
                                                            // this.state.detail.city.error && this.state.detail.city.error.length ? <small className="error">{this.state.detail.city.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{buildingIcon}</span>
                                                    {this.state.showCityDropdown ? <div className='city-value'>
                                                        {this.state.cityDropdownValue.map((elem, index) => (
                                                            <div className='pd-15' id={index} onClick={() => { this.setCityValue(elem.city) }}>{elem.city}</div>
                                                        ))}
                                                    </div> : ""}
                                                    <DebounceInput type="text"  id="city" name="city" value={this.state.detail.city.value} placeholder="Enter city" required style={{ textTransform: "capitalize" }} onChange={(event) => this.inputChange(event)} debounceTimeout={200} />
                                                    <Form.Label htmlFor="city" className="sale-label required">City</Form.Label>
                                                </div>
                                                <div className="sale-field sale-field-client">
                                                    <div className="text">
                                                        {
                                                            this.state.detail.client.error && this.state.detail.client.error.length ? <small className="error">{this.state.detail.client.error}</small> : null
                                                        }
                                                    </div>
                                                    <span className="sale-field-icon" aria-hidden="true">{userIcon}</span>
                                                    <Form.Control type="text" id="client" name="client" value={this.state.detail.client.value} placeholder="Enter client name (optional)" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="client" className="sale-label">Client Name</Form.Label>
                                                </div>
                                            </Form>

                                        </div>
                                    }
                                    {this.state.currentPage === 2 &&
                                        <div className="sale-card sale-settings-card">
                                            <h6 className="sale-title">Sale Settings</h6>
                                            <Form>
                                                <div className="sale-settings-grid">
                                                    <div className="sale-field sale-field-full sale-field-timezone">
                                                        <div className="text">
                                                            {
                                                                this.state.settings.timezoneid.error && this.state.settings.timezoneid.error.length ? <small className="error">{this.state.settings.timezoneid.error}</small> : null
                                                            }
                                                        </div>
                                                        <Form.Control as="select" id="timezoneid" name="timezoneid" value={this.state.settings.timezoneid.value} placeholder=" " required onChange={(event) => this.askConfirmForTimezoneChange(event)}>

                                                            <option disabled={true} value={""} selected>Select Time Zone</option>
                                                            {this.timezone.map((zone, index) =>
                                                                <option key={index} value={zone.id}>{zone.zonename}</option>
                                                            )}

                                                        </Form.Control>


                                                        <Form.Label htmlFor="timezoneid" className="sale-label required">Time Zone</Form.Label>
                                                    </div>

                                                    <div className="sale-field sale-field-half" style={{ marginBottom: "1%" }}>
                                                        <div className="text">
                                                            {
                                                                this.state.settings.starttime.error && this.state.settings.starttime.error.length ? <small className="error" style={{ left: "4px", top: "-9px" }}>{this.state.settings.starttime.error}</small> : null
                                                            }
                                                        </div>
                                                        <div className="datePickerClass">
                                                            <label onClick={e => this.start.state.open && e.preventDefault()
                                                            }>
                                                                <DatePicker ref={r => this.start = r}
                                                                    minDate={this.state.isSafari ? this.state.minDate ? new Date(this.state.minDate) : null : this.state.minDate}
                                                                    minTime={this.state.isSafari ? this.state.minimumTime ? new Date(moment(this.state.minimumTime)) : null : this.state.minimumTime}
                                                                   // minDate={this.state.minDate ? this.state.minDate : null} 
                                                                   // minTime={this.state.isSafari?new Date(moment()) :this.state.minimumTime} 
                                                                    openToDate={this.state.settings.starttime.value ? new Date(moment(this.state.settings.starttime.value)) : new Date(this.state.startDate)}                                                                  
                                                                    maxTime={this.state.isSafari ? this.state.minimumTime ? new Date(moment(this.state.minimumTime)).setHours(23, 59, 59) : new Date(moment()).setHours(23, 59, 59) : new Date(moment()).setHours(23, 59, 59)}
                                                                    id="starttime"
                                                                    name="starttime"
                                                                    disabled={this.state.checkSaleStatus || this.state.status === 'Started' || this.state.isLocked }
                                                                   
                                                                    className="datePicker"
                                                                    dateFormat="MM/dd/yyyy hh:mm a"
                                                                    //  value={this.state.isSafari ? moment(new Date(moment(this.state.minimumTime).format('YYYY-MM-DD hh:mm A'))) : new Date(moment(this.state.minimumTime).format('YYYY-MM-DD hh:mm A'))} 
                                                                    selected={this.state.settings.starttime.value ? new Date(moment(this.state.settings.starttime.value)) : null}
                                                                    onChange={(date) => this.inputChange({ target: { name: 'starttime', value: date } })}
                                                                   // onMonthChange={(date) => this.inputChange({ target: { name: 'starttime', value: date } })}
                                                                   // onYearChange={(date) => this.inputChange({ target: { name: 'starttime', value: date } })}
                                                                    
                                                                    onChangeRaw={(event) => event.preventDefault()}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    showTimeSelect
                                                                    showDisabledMonthNavigation
                                                                    timeFormat="hh:mm a"
                                                                    timeIntervals={15}
                                                                    placeholderText="Select Date"
                                                                    dropdownMode="select"
                                                                    popperPlacement="bottom-start"
                                                                    popperModifiers={{
                                                                        flip: {
                                                                            behavior: ["bottom"] // don't allow it to flip to be above
                                                                        },
                                                                        preventOverflow: {
                                                                            enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                                                                        },
                                                                        hide: {
                                                                            enabled: false // turn off since needs preventOverflow to be enabled
                                                                        }
                                                                    }}
                                                                    autoComplete="off"
                                                                    renderCustomHeader={({ date, changeYear, changeMonth }) => {
                                                                        const selectedYear = new Date().getFullYear() > new Date(this.state?.settings?.starttime?.value).getFullYear() ?  new Date(this.state.settings.starttime.value).getFullYear() :  new Date().getFullYear(); ;
                                                                        const startYear = selectedYear; 
                                                                        const endYear = selectedYear + 50;
                                                                    
                                                                        return (
                                                                          <div className="sale-date-header">
                                                                          
                                                                            {/* Month Dropdown */}
                                                                            <select value={date.getMonth()} onChange={(e) => changeMonth(Number(e.target.value))}>
                                                                              {Array.from({ length: 12 }, (_, index) => (
                                                                                <option key={index} value={index}>
                                                                                  {new Date(0, index).toLocaleString("default", { month: "long" })}
                                                                                </option>
                                                                              ))}
                                                                            </select>
                                                                              {/* Custom Year Dropdown */}
                                                                                <select value={date.getFullYear()} onChange={(e) => changeYear(Number(e.target.value))}>
                                                                                    {Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index).map((year) => (
                                                                                        <option key={year} value={year}>{year}</option>
                                                                                    ))}
                                                                                </select>
                                                                          </div>
                                                                        );
                                                                      }} />
                                                                <i className="fa fa-calendar sale-date-icon" aria-hidden="true"></i>
                                                            </label>
                                                        </div>
                                                        <Form.Label htmlFor="starttime" className="sale-label required dateLabel">Start Time</Form.Label>
                                                    </div>
                                                    <div className="sale-field sale-field-half" style={{ marginBottom: "-5px" }}>
                                                        <div className="text">
                                                            {
                                                                this.state.settings.endtime.error && this.state.settings.endtime.error.length ? <small className="error" style={{ left: "4px", top: "-9px" }}>{this.state.settings.endtime.error}</small> : null
                                                            }
                                                        </div>
                                                        <div className="datePickerClass">
                                                            <label onClick={e => this.end.state.open && e.preventDefault()}>
                                                                <DatePicker ref={r => this.end = r}
                                                                    minDate={ this.state.settings.starttime.value < this.state.minDate ? this.state.minDate : new Date(this.state.settings.starttime.value) }
                                                                 // minDate={this.state.isSafari ? this.state.minDate ? new Date(this.state.minDate) : null : this.state.minDate} 
                                                                //  minTime={this.state.isSafari ? this.state.EndDateminTime ? new Date(moment(this.state.EndDateminTime)) : new Date(moment()) :this.state.minimumTime}
                                                                disabled={this.state.checkSaleStatus || this.checkEndTimeDisbale() || this.state.isLocked}
                                                                minTime={this.state.isSafari ? this.state.EndDateminTime ? new Date(moment(this.state.EndDateminTime)) : null : this.state.EndDateminTime}
                                                                maxTime={this.state.isSafari ? new Date(moment(this.state.EndDateminTime)).setHours(23, 59, 59) : new Date(moment(this.state.EndDateminTime)).setHours(23, 59, 59)}
                                                                // maxTime={this.state.isSafari ? new Date(moment(this.state.EndDateminTime)).setHours(23, 59, 59) : new Date(moment(this.state.EndDateminTime)).setHours(23, 59, 59)}
                                                                    id="endtime"
                                                                    name="endtime"                                                                    
                                                                    openToDate={new Date(moment(this.state.settings.endtime.value)) && this.state.settings.endtime.value !== "" ? new Date(moment(this.state.settings.starttime.value)) >  new Date(moment(this.state.settings.endtime.value)) ? new Date(moment(this.state.settings.starttime.value)) : new Date(moment(this.state.settings.endtime.value)) : new Date(this.state.startDate)}
                                                                    className="datePicker"
                                                                    dateFormat="MM/dd/yyyy hh:mm a"
                                                                 
                                                                    //value={this.state.settings.endtime.value} 
                                                                    selected={this.state.settings.endtime.value ? new Date(moment(this.state.settings.endtime.value)) : null}
                                                                    // selected={this.state.settings.endtime.value} 
                                                                    onChange={(date) => this.inputChange({ target: { name: 'endtime', value: new Date(date) === new Date() ? new Date(date) : this.state.settings.starttime.value ? date : new Date(date).setHours(0, 0, 0) } })}
                                                                    onChangeRaw={(event) => event.preventDefault()}
                                                                  //  onMonthChange={(date) => this.inputChange({ target: { name: 'endtime', value: new Date(date) === new Date() ? new Date(date) : this.state.settings.starttime.value ? date : new Date(date).setHours(0, 0, 0) } })}
                                                                  //  onYearChange={(date) => this.inputChange({ target: { name: 'endtime', value: new Date(date) === new Date() ? new Date(date) : this.state.settings.starttime.value ? date : new Date(date).setHours(0, 0, 0) } })}
                                                                    peekNextMonth showMonthDropdown showYearDropdown showTimeSelect
                                                                    timeFormat="hh:mm a"
                                                                    timeIntervals={15}
                                                                    placeholderText="Select Date "
                                                                    dropdownMode="select"
                                                                    popperPlacement="bottom-start"
                                                                    popperModifiers={{
                                                                        flip: {
                                                                            behavior: ["bottom"] // don't allow it to flip to be above
                                                                        },
                                                                        preventOverflow: {
                                                                            enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                                                                        },
                                                                        hide: {
                                                                            enabled: false // turn off since needs preventOverflow to be enabled
                                                                        }
                                                                    }}
                                                                    autoComplete="off" 
                                                                    renderCustomHeader={({ date, changeYear, changeMonth }) => {
                                                                        const selectedYear = new Date(this.state.settings.starttime.value).getFullYear() > new Date().getFullYear() ?  new Date(this.state.settings.starttime.value).getFullYear() : new Date(this.state.settings.endtime.value).getFullYear() < new Date().getFullYear() ?  new Date(this.state.settings.endtime.value).getFullYear() :  new Date().getFullYear(); 
                                                                        const startYear = selectedYear; 
                                                                        const endYear = selectedYear + 50;
                                                                    
                                                                        return (
                                                                          <div className="sale-date-header">
                                                                          
                                                                            {/* Month Dropdown */}
                                                                            <select value={date.getMonth()} onChange={(e) => changeMonth(Number(e.target.value))}>
                                                                              {Array.from({ length: 12 }, (_, index) => (
                                                                                <option key={index} value={index}>
                                                                                  {new Date(0, index).toLocaleString("default", { month: "long" })}
                                                                                </option>
                                                                              ))}
                                                                            </select>
                                                                              {/* Custom Year Dropdown */}
                                                                                <select value={date.getFullYear()} onChange={(e) => changeYear(Number(e.target.value))}>
                                                                                    {Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index).map((year) => (
                                                                                        <option key={year} value={year}>{year}</option>
                                                                                    ))}
                                                                                </select>
                                                                          </div>
                                                                        );
                                                                      }}
                                                                    onCalendarClose={() => this.state.saleid ? this.calendarClose(this.state.settings.endtime.value) : ''} />

 
                                                                <i className="fa fa-calendar sale-date-icon" aria-hidden="true"></i>
                                                            </label>
                                                        </div>
                                                        <Form.Label htmlFor="endtime" className="sale-label required dateLabel" >End Time</Form.Label>
                                                    </div>
                                                    <div className="sale-field sale-field-full sale-field-closeduration">
                                                        <div className="text">
                                                            {
                                                                this.state.settings.closeduration.error && this.state.settings.closeduration.error.length ? <small className="error">{this.state.settings.closeduration.error}</small> : null
                                                            }
                                                        </div>
                                                        <Form.Control as="select" id="closeduration" name="closeduration" value={this.state.settings.closeduration.value} defaultValue={90} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                            <option disabled={true} value={""} selected>Select duration</option>
                                                            {this.duration.map((minute, index) =>
                                                                <option key={index} selected={minute.value === 90 ? 'selected' : ''} value={minute.value}>{minute.text}</option>
                                                            )}

                                                        </Form.Control>
                                                        <Form.Label htmlFor="closeduration" className="sale-label required">Close Duration (minutes)</Form.Label>
                                                    </div>
                                                    {/* <div>
                                                    <Row>
                                                        <Col md={6} xs={{ span: 12, order: 1 }}>
                                                            <div className="float-control">
                                                                <div className="text">
                                                                    {
                                                                        this.state.settings.duration.error && this.state.settings.duration.error.length ? <small className="error">{this.state.settings.duration.error}</small> : null
                                                                    }
                                                                </div>
                                                                <Form.Control as="select" id="duration" name="duration" value={this.state.settings.duration.value} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                                    <option style={{ display:"none" }} selected>Select Duration</option>
                                                                    {[...Array(12)].map((e, i) =>
                                                                        <option key={(i + 1) * 5} value={(i + 1) * 5}>{(i + 1) * 5}</option>
                                                                    )}
                                                                </Form.Control>
                                                                <Form.Label htmlFor="duration" className="required">Staggered Duration</Form.Label>
                                                            </div>
                                                        </Col>
                                                        <Col md={6} xs={{ span: 12, order: 2 }}>
                                                            <div className="float-control">
                                                                <div className="text">
                                                                    {
                                                                        this.state.settings.staggeredtime.error && this.state.settings.staggeredtime.error.length ? <small className="error">{this.state.settings.staggeredtime.error}</small> : null
                                                                    }
                                                                </div>
                                                                <Form.Control as="select" id="staggeredtime" name="staggeredtime" value={this.state.settings.staggeredtime.value} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                                    <option style={{ display:"none" }} selected >Select Time</option>
                                                                    {[...Array(12)].map((e, i) =>
                                                                        <option key={(i + 1) * 5} value={(i + 1) * 5}>{(i + 1) * 5}</option>
                                                                    )}
                                                                </Form.Control>
                                                                <Form.Label htmlFor="staggeredtime" className="required">Time</Form.Label>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div> */}
                                                    {/* <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.staggeredgroup.error && this.state.settings.staggeredgroup.error.length ? <small className="error">{this.state.settings.staggeredgroup.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="select" id="staggeredgroup" name="staggeredgroup" value={this.state.settings.staggeredgroup.value} placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                                        <option style={{ display:"none" }} selected >Select Group</option>
                                                        {this.category.map(cato =>
                                                            <option key={cato.id} value={cato.id}>{cato.category}</option>
                                                        )}

                                                    </Form.Control>
                                                    <Form.Label htmlFor="staggeredgroup" className="required">Staggered Group By</Form.Label>
                                                </div> */}
                                                    <div className="sale-field sale-field-half">
                                                        <div className="text">
                                                            {
                                                                this.state.settings.tax.error && this.state.settings.tax.error.length ? <small className="error">{this.state.settings.tax.error}</small> : null
                                                            }
                                                        </div>
                                                        <Form.Control type="text" id="tax" name="tax" value={this.state.settings.tax.value} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                        <Form.Label htmlFor="tax" className="sale-label required">Tax (%)</Form.Label>
                                                    </div>
                                                    <div className="sale-field sale-field-half">
                                                        <div className="text">
                                                            {
                                                                this.state.settings.buyerspremium.error && this.state.settings.buyerspremium.error.length ? <small className="error">{this.state.settings.buyerspremium.error}</small> : null
                                                            }
                                                        </div>
                                                        <Form.Control type="text" id="buyerspremium" name="buyerspremium" value={this.state.settings.buyerspremium.value} placeholder=" " onChange={(event) => this.inputChange(event)} />
                                                        <Form.Label htmlFor="buyerspremium" className="sale-label required">Buyers Premium (%)</Form.Label>
                                                    </div>
                                                </div>
                                                <div className="sale-checkbox-row">
                                                    <Form.Check type="checkbox" id="applytaxonbp" className={`${this.state.settings.applytaxonbp?.error ? 'error-control' : ''}`} name="applytaxonbp" label="Apply Tax On Buyers Premium" checked={this.state.settings.applytaxonbp?.value.toString() === 'true' || this.state.settings.applytaxonbp?.value === 1} onChange={(event) => this.inputChange(event)} />
                                                </div>
                                                {/* <div className="d-flex flex-column mb-1">
                                                    <Form.Check type="checkbox" id="isshippable" className={`${this.state.settings.isshippable?.error ? 'error-control' : ''}`} name="isshippable" label="Shippable Items" checked={this.state.settings.isshippable?.value.toString() === 'true' || this.state.settings.isshippable?.value === 1} onChange={(event) => this.inputChange(event)} />
                                                </div> */}
                                                <div className="sale-field-heading">
                                                    <label className="sale-label required">Item Receipt Methods</label>
                                                </div>
                                                <div className="sale-field-spacer" >
                                                    {/* <Form.Check  inline type="radio" id="isshippable" disabled={!this.state.shipping && !this.state.delivery} className={`${this.state.settings.isshippable?.error ? 'error-control' : ''}`} name="isshippable" label="Mark all items on this sale as shippable"  checked={ !this.state.deliveryvalid || !this.state.shippingvalid } onChange={(event) => this.inputChange(event, "shipping")} />
                                                    <Form.Check  inline type="radio" id="pickuponly"  disabled={!this.state.pickup} className={`${this.state.settings.isshippable?.error ? 'error-control' : ''}`} name="isshippable" label="Mark all items on this sale as pickup"   checked={ !this.state.pickupvalid }onChange={(event) => this.inputChange(event,  "pickup")} /> */}
                                                </div>
                                                <div className="sale-checkboxes">
                                                    <Form.Check inline type="checkbox" checked={this.state.settings.itemreceiptmethod.value?.pickup} name="pickup" label="Pickup" id="ispickup" onChange={(event) => this.receiptCheckBox(event)} disabled={this.state.invalidIrm.includes('pickup')} />
                                                    <Form.Check inline type="checkbox"  checked={this.state.settings.itemreceiptmethod.value?.delivery} name="delivery" label="Delivery" id="isdelivery" onChange={(event) => this.receiptCheckBox(event)}disabled={this.state.invalidIrm.includes('delivery')}/>
                                                    <Form.Check style={{ marginRight: "0" }} inline type="checkbox"checked={this.state.settings.itemreceiptmethod.value?.shipping} name="shipping" label="Shipping" id="isshipping" onChange={(event) => this.receiptCheckBox(event)} disabled={this.state.invalidIrm.includes('shipping')}/>
                                                </div>
                                                <div className="text">
                                                     {
                                                        this.state?.settings?.itemreceiptmethod?.error ? <small className="error text-danger">{this.state.settings?.itemreceiptmethod.error}</small> : null
                                                    }
                                                </div>
                                               

                                                <div className="sale-field sale-field-full" style={{ top: "8px" }}>
                                                    <div className="text">
                                                        {
                                                            this.state.settings.pickupinfo.error && this.state.settings.pickupinfo.error.length ? <small className="error">{this.state.settings.pickupinfo.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="textarea" id="pickupinfo" name="pickupinfo" value={this.state.settings.pickupinfo.value} maxLength="500" style={{ height: '100px' }} placeholder="The pickup will be on Day/Date/Time Range in City/Zip and the exact address will be provided on winning bidder invoices." onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="pickupinfo" className="sale-label">Pickup Information</Form.Label>
                                                    <span className="align-self-end ml-auto" style={{ color: '#878787', marginBottom: '-7px' }}>{this.state.chars_left - this.state.settings.pickupinfo.value.length}/500</span>
                                                </div>
                                                <div className="sale-settings-grid">
                                                    <div className="sale-field sale-field-half sale-field-pickuptime">
                                                        <div className="text">
                                                     
                                                            {
                                                                this.state.settings.pickuptime.error && this.state.settings.pickuptime.error.length ? <small className="error" style={{ left: "4px", top: "-9px" }}>{this.state.settings.pickuptime.error}</small> : null
                                                            }
                                                        </div>
                                                        <div className="datePickerClass">
                                                            <label onClick={e => this.pickup.state.open && e.preventDefault()
                                                            }>
                                                                <DatePicker ref={r => this.pickup = r}
                                                                     minDate={this.state.settings.endtime.value  && this.state.settings.endtime.value  < this.state.minDate ? this.state.minDate : this.state.settings.endtime.value ? new Date(new Date(this.state.settings.endtime.value).setDate(new Date(this.state.settings.endtime.value).getDate() + 1)) : new Date(new Date(this.state.minDate).setDate(new Date(this.state.minDate).getDate() + 1))} 
                                                                     openToDate={ this.state.settings.endtime.value ? new Date(this.state.settings.pickuptime.value) < new Date() && this.state.settings.pickuptime.value ? new Date(this.state.settings.pickuptime.value) : new Date(this.state.settings.endtime.value) > new Date() ? new Date(this.state.settings.endtime.value) : new Date() : new Date(this.state.startDate)}                                                                    // minTime={this.state.settings.endtime.value ? this.state.pickupminTime ? new Date(this.state.pickupminTime) :  new Date(this.state.settings.endtime.value).setMinutes(new Date(this.state.settings.endtime.value).getMinutes() + 15) : this.state.EndDateminTime} 
                                                                    // maxTime={this.state.settings.pickuptime.value ? new Date(moment(this.state.settings.pickuptime.value)).setHours(23, 59, 59) :  new Date(moment()).setHours(23, 59, 59)}
                                                                    disabled={ this.state.checkSaleStatus }
                                                                    id="pickuptime"
                                                                    name="pickuptime"
                                                                    className="datePicker"
                                                                    dateFormat="MM/dd/yyyy"
                                                                    selected={
                                                                        this.state.settings.pickuptime.value && !isNaN(new Date(this.state.settings.pickuptime.value).getTime())
                                                                            ? new Date(this.state.settings.pickuptime.value)
                                                                            : null
                                                                    }
                                                                    onChange={(date) => this.inputChange({ target: { name: 'pickuptime', value: date } })}
                                                                    onChangeRaw={(event) => event.preventDefault()}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    showDisabledMonthNavigation
                                                                    timeIntervals={15}
                                                                    placeholderText="Select Date"
                                                                    dropdownMode="select"
                                                                    popperPlacement="bottom-start"
                                                                    popperModifiers={{
                                                                        flip: {
                                                                            behavior: ["bottom"] // don't allow it to flip to be above
                                                                        },
                                                                        preventOverflow: {
                                                                            enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                                                                        },
                                                                        hide: {
                                                                            enabled: false // turn off since needs preventOverflow to be enabled
                                                                        }
                                                                    }}
                                                                    renderCustomHeader={({ date, changeYear, changeMonth }) => {
                                                                        const selectedYear = new Date(this.state.settings.starttime.value).getFullYear() > new Date().getFullYear() ?  new Date(this.state.settings.starttime.value).getFullYear() : new Date(this.state.settings.pickuptime.value).getFullYear() < new Date(this.state.settings.endtime.value).getFullYear() ? new Date(this.state.settings.pickuptime.value).getFullYear() :   new Date(this.state.settings.endtime.value).getFullYear() < new Date().getFullYear() ?  new Date(this.state.settings.endtime.value).getFullYear() :  new Date().getFullYear(); 
                                                                        const startYear = selectedYear; 
                                                                        const endYear = selectedYear + 50;
                                                                    
                                                                        return (
                                                                          <div className="sale-date-header">
                                                                            {/* Month Dropdown */}
                                                                            <select value={date.getMonth()} onChange={(e) => changeMonth(Number(e.target.value))}>
                                                                              {Array.from({ length: 12 }, (_, index) => (
                                                                                <option key={index} value={index}>
                                                                                  {new Date(0, index).toLocaleString("default", { month: "long" })}
                                                                                </option>
                                                                              ))}
                                                                            </select>
                                                                              {/* Custom Year Dropdown */}
                                                                                <select value={date.getFullYear()} onChange={(e) => changeYear(Number(e.target.value))}>
                                                                                    {Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index).map((year) => (
                                                                                        <option key={year} value={year}>{year}</option>
                                                                                    ))}
                                                                                </select>
                                                                          </div>
                                                                        );
                                                                      }}
                                                                    autoComplete="off" />
                                                                <i className="fa fa-calendar sale-date-icon" aria-hidden="true"></i>
                                                            </label>
                                                        </div>
                                                        <Form.Label htmlFor="pickuptime" className="sale-label dateLabel">Scheduled Pickup Date</Form.Label>
                                                    </div>
                                                </div>
                                                    <div className="sale-field sale-field-full">
                                                    <div className="text">
                                                        {
                                                            this.state.settings.provenance.error && this.state.settings.provenance.error.length ? <small className="error">{this.state.settings.provenance.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="textarea" id="provenance" name="provenance" value={this.state.settings.provenance.value} maxLength="750" style={{ height: '100px' }} placeholder="Tell about the owners of this estate and what they collected or how they cared for or acquired their items or other things such as: animal/nature/music/sports lover, interesting career, lifelong passions" onChange={(event) => this.inputChange(event)} />
                                                    <Form.Label htmlFor="provenance" className="sale-label required">Sale Provenance</Form.Label>
                                                    <span className="align-self-end ml-auto" style={{ color: '#878787', marginBottom: '-7px' }}>{this.state.saleProvenanceCharLeft - this.state.settings.provenance.value.length}/750</span>
                                                </div>
                                                {formControl.map((control, index) =>
                                                    <div key={index} className="sale-template-field" >
                                                        <div key={index} className="sale-template-row mb-3" >
                                                            <div className="sale-template-content">
                                                                <Form.Label className="sale-label templateLabel required" htmlFor={control.key}>{control.value}</Form.Label>
                                                                <div className="templateClass">
                                                                    <div style={{ overflow: "hidden overlay", height: "95px", padding: "10px 15px" }} className="ql-editor" >{this.state.settings[control.key] ? this.state.settings[control.key].value && this.state.settings[control.key].value !== '{}' ?
                                                                        <div style={{ paddingRight: "4%" }} dangerouslySetInnerHTML={{ __html: JSON.parse(this.state.settings[control.key].value)['body'] }} /> : <p style={{ color: "#b3b1b1" }}>Click edit icon to add text</p> : ''} </div>
                                                                </div>
                                                            </div>
                                                            <div className="sale-template-actions">
                                                                <div className="sale-template-action">
                                                                    <img src={`/static/icons/table/view.svg`} alt="view" height="25px" width="25px" className="action-button" onClick={() => this.showViewModal(control.key)} />
                                                                </div>
                                                                <div className="sale-template-action">
                                                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/edit.svg`} alt="edit" height="25px" width="25px" className="action-button" onClick={() => this.showEditModal(control.key)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-block text">
                                                            {
                                                                this.state.settings[control.key].error && this.state.settings[control.key].error.length ? <small className="error text-danger">{this.state.settings[control.key].error}</small> : null
                                                            }
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="sale-settings-grid">
                                                    <div className="sale-field sale-field-half sale-field-staffcheckpoint" style={{ top: "-5px" }}>
                                                        <Form.Control as="select" id="salestaffcheckpointid" name="salestaffcheckpointid" value={this.state.settings.salestaffcheckpointid.value} placeholder = ""  onChange={(event) => this.inputChange(event)}>
                                                                <option value={""} selected>Select Staff Checkpoint</option>
                                                                {this.state.checkpointList.map((item, index) =>
                                                                    <option key={index} value={item.id}>{item.question}</option>
                                                                )}
                                                        </Form.Control>
                                                        <Form.Label htmlFor="salestaffcheckpointid" className="sale-label">Staff Checkpoint</Form.Label>
                                                    </div>
                                                </div>

                                                {this.state.checkpointInput ?
                                                    <div className="sale-field sale-field-full" style={{ top: "8px" }}>
                                                        <div className="text">
                                                            {
                                                                this.state.settings.salestaffcheckpoint.error && this.state.settings.salestaffcheckpoint.error.length ? <small className="error">{this.state.settings.salestaffcheckpoint.error}</small> : null
                                                            }
                                                        </div>
                                                        <Form.Control as="textarea" id="salestaffcheckpoint" name="salestaffcheckpoint" value={this.state.settings.salestaffcheckpoint.value} maxLength="200" style={{ height: '100px' }} placeholder= "Create your own - up to 200 characters" onChange={(event) => this.inputChange(event)} />
                                                        <Form.Label htmlFor="salestaffcheckpoint" className="sale-label required">Create your own question</Form.Label>
                                                        <span className="align-self-end ml-auto" style={{ color: '#878787', marginBottom: '-7px' }}>{this.state.chars_left_Checkpoint - this.state.settings.salestaffcheckpoint.value.length}/200</span>
                                                    </div> : ''
                                                }
                                            </Form>
                                            <Modal id="saleTemplate" show={this.state.settings.viewModal} size="lg" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                                                <Modal.Body className="templateClass">
                                                    {
                                                        this.state.settings[this.viewModalName] ? this.state.settings[this.viewModalName].value && this.state.settings[this.viewModalName].value !== '{}' ?

                                                        <div className="ql-editor" style={{ padding: "1rem" }} dangerouslySetInnerHTML={{ __html: JSON.parse(this.state.settings[this.viewModalName].value)['body'] }} />
                                                        : '' : ''}
                                                </Modal.Body>
                                                <Modal.Footer className="justify-content-center">
                                                    <Button variant="secondary" onClick={() => this.setState({ ...this.state, settings: { ...this.state.settings, viewModal: false } })}>Close</Button>
                                                </Modal.Footer>
                                            </Modal>
                                            <Modal show={this.state.settings.editModal} size="lg" animation={false} onHide={() => this.setState({ ...this.state })} onShow={this.textEditorOnShow}>
                                                <Modal.Body className="templateClass">
                                                    <div className="text-editor">
                                                        <div className="wrapper">
                                                        <ReactQuill theme="snow" modules={this.modules} value={this.state.settings[this.editModalName] ? this.state.settings[this.editModalName].value && this.state.settings[this.editModalName].value !== '{}' ? JSON.parse(this.state.settings[this.editModalName].value)['body'] : '' : ''} onChange={this.templateChange} ref={(el) => this.textEditorRef = el} onKeyDown={this.handleKeyDown} />

                                                        </div>
                                                    </div>
                                                    <div className="d-flex" style={{ margin: "1% 3%", float: "right" }}>
                                                        <Button style={{ marginRight: "4%", backgroundColor: '#00263E ' }} onClick={() => this.setState({ ...this.state, settings: { ...this.state.settings, editModal: false } })}>Cancel</Button>
                                                        <Button className="save-button" onClick={() => this.saveTemplateChange()}>Save</Button>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    }
                                    <div className="align-items-center justify-content-center mb-5 mt-4">
                                        <div id="toaster" className={this.state.saleStatus.show || this.state.stateCityError ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} >
                                            {
                                                this.state.saleStatus.show ?
                                                    <ToasterMessage type={this.state.saleStatus.type} message={this.state.saleStatus.message} className="alert-handle"></ToasterMessage>
                                                    : this.state.isLocked ? <p className='text-danger text-center'>Sale has started closing and any actions on this sale is not allowed</p> :  null
                                            }
                                        </div>
                                        <div className="sale-actions mb-5">
                                            {this.state.currentPage === 2 &&
                                                <Button className="sale-button" onClick={() => this.setStep(1)}>Previous</Button>
                                            }
                                            <Button className="sale-button" onClick={() => { this.props.history.push({ pathname: '/sales', state: this.props.location.state }) }}>Cancel</Button>
                                            <Button className="btn-save btn-secondary" disabled={this.state.saleStatus.type === 'success' || this.state.loading || !this.state.cityStateIsValid || this.state.formErrorMessage || this.state.isLocked } onClick={() => this.checkFieldValidations()}> {!this.edit ? 'Update' : ''}{this.edit && this.state.currentPage === 1 ? 'Next' : ' '}{this.edit && this.state.currentPage === 2 ? 'Save ' : ''}{this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </Container>
                        <Modal centered show={this.state.showConfirmModal && !this.state.loading} className="confirmModal justify-content-center" onHide={() => this.setState({ ...this.state })}>
                            <Modal.Body className="p-4 text-center">
                                Do you want to add media to this sale ?
                                <div className="d-flex flex-row justify-content-center mt-4">
                                    <Button className="btn-white mx-1" disabled={this.state.loading} onClick={() => this.submitForm(false)}> No, save & exit</Button>
                                    <Button className="save-button mx-1" disabled={this.state.loading} onClick={() => this.submitForm(true)}> Yes, add media</Button>
                                </div>
                            </Modal.Body>
                        </Modal>
                        <Modal centered show={this.state.showUpdateModal && !this.state.loading} className="confirmModal justify-content-center" onHide={() => this.setState({ ...this.state })}>
                            <Modal.Body className="p-4 text-center">
                            The update to your sale settings will only affect new item listings added after this update. You must use the Bulk Update option from the Sale Dashboard if you want previously created items to be updated. <br /> would you like to proceed?
                                <div className="d-flex flex-row justify-content-center mt-4">
                                    <Button className="btn-white mx-1" disabled={this.state.loading} onClick={() => this.restoreState()}> No</Button>
                                    <Button className="save-button mx-1" disabled={this.state.loading} onClick={() => this.submitForm(true)}> Yes</Button>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                }
                {this.state.currentPage === 3 &&
                    <div className="sale-media-page">
                        {/* <ul className="d-flex justify-content-center align-items-center container">
                            <li className="stepper"><Button className={this.state.currentPage === 1 ? "active" : ''} disabled={this.state.currentPage === 1 || !this.edit ? false : true} onClick={() => this.setStep(1)}><span className="numberCount">1</span>Detail</Button></li>
                            <li className="stepper"><Button className={this.state.currentPage === 2 ? "active" : ''} disabled={this.state.currentPage === 2 || !this.edit ? false : true} onClick={() => this.setStep(2)}><span className="numberCount">2</span>Settings</Button></li>
                            <li className="stepper"><Button className={this.state.currentPage === 3 ? "active" : ''} disabled={this.state.currentPage === 3 || !this.edit ? false : true} onClick={() => this.setStep(3)}><span className="numberCount">3</span>Media</Button></li>
                        </ul> */}
                        <div className="sale-container sale-media-container">
                            {this.state.formLoading ?
                                <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                </div> :
                                <div className="mb-5">
                                    {this.state.currentPage === 3 &&
                                        <div style={{ margin: '0 8px' }}>
                                            {/* <div className="d-flex flex-column salesMedia">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <h6 className="w-50" >Sale Banner Photo<span style={{ color: "#878787" }}> (Suggested image size 1200 &times; 250 pixels)</span></h6>
                                                    {this.state.media.banner.imgSrc ?
                                                        <div>
                                                            <Form.Control id="img-banner" name="banner" type="file" onChange={this.changeImage} accept={IMAGE_TYPES} hidden />
                                                            <Button disabled={true} className="uploadButton" style={{ width: "130px", borderRadius: "0px" }} onClick={this.uploadBannerImage}>Change Image</Button>
                                                        </div>
                                                        : ''}
                                                </div>
                                                <div className="d-flex flex-row align-items-center justify-content-center banner mt-1" style={{ border: '2px dashed #c5c5c5' }}>

                                                    {this.state.media.banner.imgSrc ?
                                                        <img src={this.state.media.banner.imgSrc} alt="invalid" style={{ width: '100%', height: '15.35vw' }} /> : null}
                                                    {this.state.media.banner.imgSrc === null ?
                                                        <div className="d-flex flex-column justify-content-center align-items-center w-100" style={{ height: '250px' }}>
                                                            <Form.Control disabled={true} id="img-banner" name="banner" type="file" onChange={this.changeImage} accept={IMAGE_TYPES} hidden />
                                                            <i className=" fa fa-plus rounded-circle bg-secondary text-white p-3 clickable" id="img-banner" onClick={this.uploadBannerImage}></i>
                                                            <h6 className="text-secondary my-3">Add Banner Image</h6>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div> */}

                                            <div className="sale-media-section">
                                                <span className="sale-media-heading">
                                                    <div>Primary Sale Cover Photo</div>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>
                                                        {'This is the largest image to display. Please use a 600W x 400H size image. Landscape orientation recommended'}</Tooltip>}>
                                                        <i className="sale-heading-info" aria-label="More information">{infoIcon}</i>
                                                    </OverlayTrigger>
                                                </span>
                                                <div className="sale-upload-grid sale-upload-primary">
                                                    <div className="sale-upload-box">
                                                        <div className={`sale-upload-preview ${this.state.media.profile.imgSrc ? 'profile-rounded' : ''}`}>
                                                            <Form.Control id="img-profile" type="file" name="profile" onChange={this.changeImage} accept={IMAGE_TYPES} hidden />
                                                            {
                                                                this.state.media.profile.imgSrc ?
                                                                    <img src={this.state.media.profile.imgSrc} alt="invalid profile" width="100%" height="100%" /> :
                                                                    <div className="sale-upload-empty">
                                                                        <img src={`${process.env.PUBLIC_URL}/static/images/image_thumbnail1.png`} alt="Photo placeholder" height="48" width="48" />
                                                                    </div>
                                                            }
                                                        </div>
                                                        <div className="sale-upload-copy">
                                                            {
                                                                this.state.processSaleImage ? 
                                                                <div className="d-flex text-secondary" style={{gap: '0.5rem'}}>
                                                                    <div>Processing...</div>
                                                                    <Spinner as="div" animation="border" size="sm" aria-hidden="true" />
                                                                </div> : 
                                                                <span className="text-secondary clickable" onClick={this.uploadProfileImage}>
                                                                    {
                                                                        this.state.media.profile.imgSrc ? 'Change Image' : 'Add Image'
                                                                    }
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='mt-3 mb-3 d-flex align-items-center justify-content-center text-center font-weight-bold' style={{ color: "red" }}>{this.state.setSaleImageErrorMessage}</div>
                                                <span className="sale-media-heading">
                                                    <div>Secondary Sale Cover Photos</div>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>
                                                        {'These are the smaller images that display in front of the Primary Sale image. Please use a 400W x 400H size image. Portrait orientation recommended'}</Tooltip>}>
                                                        <i className="sale-heading-info" aria-label="More information">{infoIcon}</i>
                                                    </OverlayTrigger>
                                                </span>
                                                <div className="sale-upload-grid sale-upload-secondary">
                                                    <div className="sale-upload-boxes">
                                                        {
                                                            this.state.itemMedia.map((elem, index) => {
                                                                return (
                                                                    <div key={`item-${index}`} className="sale-upload-box">
                                                                        <div className={`sale-upload-preview ${elem.imgSrc ? 'profile-rounded' : ''}`}>
                                                                            <Form.Control id={`item-${index}`} type="file" name="item" onChange={(event) => {this.changeImage(event, index)}} accept={IMAGE_TYPES} hidden />
                                                                            {
                                                                                elem.imgSrc ? (
                                                                                    <img src={elem.imgSrc} alt="invalid profile" width="100%" height="100%" />
                                                                                ) : (
                                                                                    <div className="sale-upload-empty clickable" onClick={() => this.uploadItemImage(`item-${index}`)}>
                                                                                        <img src={`${process.env.PUBLIC_URL}/static/images/image_thumbnail1.png`} alt="Photo placeholder" height="48" width="48" />
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>

                                                                        <div className="sale-upload-copy">
                                                                            {
                                                                                this.state.processItemImageIndex === null ? 
                                                                                <span className="text-secondary clickable" onClick={() => this.uploadItemImage(`item-${index}`)}>
                                                                                    {elem.imgSrc ? 'Change Image' : 'Add Image'}
                                                                                </span> : 
                                                                                this.state.processItemImageIndex === index ? 
                                                                                <div className="d-flex text-secondary" style={{gap: '0.5rem'}}>
                                                                                    <div>Processing...</div>
                                                                                    <Spinner as="div" animation="border" size="sm" aria-hidden="true" />
                                                                                </div> : null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </div>  
                                                <div className='mt-3 mb-3 d-flex align-items-center justify-content-center text-center font-weight-bold' style={{ color: "red" }}>{this.state.setItemImageErrorMessage}</div>   
                                                <div className="sale-info-banner"><span className="sale-info-icon">i</span><span>*Items cannot be moved to Ready until all Sale Cover Photos have been added and saved.</span></div>
                                            </div>  
                                        </div>
                                    }
                                    <div className="align-items-center justify-content-center mb-5 mt-4">
                                        <div id="toaster" className={this.state.saleStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                            {
                                                this.state.saleStatus.show ?
                                                    <ToasterMessage type={this.state.saleStatus.type} message={this.state.saleStatus.message} className="alert-handle"></ToasterMessage>
                                                    : null
                                            }
                                        </div>
                                        <div className="sale-actions mb-5">
                                            <Button className="sale-button sale-button-secondary" onClick={() => { this.props.history.push({ pathname: '/sales', state: this.props.location.state }) }}>Cancel</Button>
                                            <Button className="sale-button sale-button-primary" disabled={this.state.media.profile.imgSrc && this.state.itemMedia.filter(img => img.imgSrc).length === this.state.itemMedia.length && !this.state.loading && this.state.saleStatus.type !== 'success' ? false : true} onClick={() => { this.edit ? this.submitImage() : this.submitForm() }}>Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>}
                <Modal show={this.state.media.modal} size="lg" animation={false} onHide={() => this.setState({ ...this.state })}>
                    <Modal.Header>
                        <Button type="button" onClick={this.cancelImage} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="doka d-flex flex-column align-items-center justify-content-center">
                        <div className={this.currentImage === 'banner' ? 'doka-banner-layout' : 'doka-profile-layout'} style={{ width: '100%' }}>
                            <DokaImageEditor {...getEditorDefaults(this.currentImage === 'banner' ? null : this.profileTargetImage)}
                                {...this.imageEditorDefaults} src={this.currentImage == "item" ? this.state.itemMedia?.[this.imageIndex]?.tempImg : this.state.media?.[this.currentImage]?.tempImg} onProcess={this.setImage} />
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.timezoneChangeConfirm} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body>
                        <div className="mt-3">
                            <div className="d-flex flex-row justify-content-center text-center">
                                Are you sure you want to update the time zone for this sale?
                            </div>
                            <div className="d-flex timezone-confirm-button justify-content-center mt-3">
                                <Button
                                    onClick={() => this.setState({ timezoneChangeConfirm: false })}
                                    className="btn-white"
                                >No</Button>
                                <Button onClick={() => this.changeTimeZone()} className="btn-secondary ml-2">Yes</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.saleEndTimeChangeConfirm} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body>
                        <div className="mt-3">
                            <div className="d-flex flex-row justify-content-center text-center">
                                Please Note: Changing the sale end date may impact payment processing due to Buyer card expiration dates.
                            </div>
                            <div className="d-flex timezone-confirm-button justify-content-center mt-3">
                                <Button onClick={() => this.setState({ saleEndTimeChangeConfirm: false })} className="btn-secondary ml-2">Ok</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}